webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(321);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ComponentOne = __webpack_require__(294);
	
	var _ComponentOne2 = _interopRequireDefault(_ComponentOne);
	
	var _ComponentTwo = __webpack_require__(295);
	
	var _ComponentTwo2 = _interopRequireDefault(_ComponentTwo);
	
	var _ClosingDate = __webpack_require__(292);
	
	var _ClosingDate2 = _interopRequireDefault(_ClosingDate);
	
	var _DemoHandsOn = __webpack_require__(297);
	
	var _DemoHandsOn2 = _interopRequireDefault(_DemoHandsOn);
	
	var _TilpaAthleteStats = __webpack_require__(303);
	
	var _TilpaAthleteStats2 = _interopRequireDefault(_TilpaAthleteStats);
	
	var _Rankings = __webpack_require__(301);
	
	var _Rankings2 = _interopRequireDefault(_Rankings);
	
	var _RandomUser = __webpack_require__(300);
	
	var _RandomUser2 = _interopRequireDefault(_RandomUser);
	
	var _Literal = __webpack_require__(299);
	
	var _Literal2 = _interopRequireDefault(_Literal);
	
	var _DateField = __webpack_require__(296);
	
	var _DateField2 = _interopRequireDefault(_DateField);
	
	var _ClubPicker = __webpack_require__(293);
	
	var _ClubPicker2 = _interopRequireDefault(_ClubPicker);
	
	var _Sheet = __webpack_require__(302);
	
	var _Sheet2 = _interopRequireDefault(_Sheet);
	
	var _SheetLine = __webpack_require__(195);
	
	var _SheetLine2 = _interopRequireDefault(_SheetLine);
	
	var _SheetFunnel = __webpack_require__(194);
	
	var _SheetFunnel2 = _interopRequireDefault(_SheetFunnel);
	
	var _Sorter = __webpack_require__(196);
	
	var _Sorter2 = _interopRequireDefault(_Sorter);
	
	var _Funnel = __webpack_require__(298);
	
	var _Funnel2 = _interopRequireDefault(_Funnel);
	
	var _Translation = __webpack_require__(197);
	
	var _Translation2 = _interopRequireDefault(_Translation);
	
	var _uiv = __webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.config.devtools = true;
	_vue2.default.use(__webpack_require__(320));
	
	var mainApp;
	try {
	  mainApp = new _vue2.default({
	    el: '#vue_container_app',
	
	    mixins: [mainMixin],
	    components: {
	      ComponentOne: _ComponentOne2.default,
	      ComponentTwo: _ComponentTwo2.default,
	      ClosingDate: _ClosingDate2.default,
	      DemoHandsOn: _DemoHandsOn2.default,
	      TilpaAthleteStats: _TilpaAthleteStats2.default,
	      RandomUser: _RandomUser2.default,
	      Rankings: _Rankings2.default,
	      Literal: _Literal2.default,
	      DateField: _DateField2.default,
	      Tabs: _uiv.Tabs,
	      ClubPicker: _ClubPicker2.default,
	      Tab: _uiv.Tab,
	
	      Sheet: _Sheet2.default,
	      SheetLine: _SheetLine2.default,
	      SheetFunnel: _SheetFunnel2.default,
	
	      Sorter: _Sorter2.default,
	      Funnel: _Funnel2.default,
	      Translation: _Translation2.default
	    }
	  });
	} catch (e) {
	  mainApp = new _vue2.default({
	    el: '#vue_container_app',
	    components: {
	      ComponentOne: _ComponentOne2.default,
	      ComponentTwo: _ComponentTwo2.default,
	      ClosingDate: _ClosingDate2.default,
	      DemoHandsOn: _DemoHandsOn2.default,
	      TilpaAthleteStats: _TilpaAthleteStats2.default,
	      RandomUser: _RandomUser2.default,
	      Rankings: _Rankings2.default,
	      Literal: _Literal2.default,
	      DateField: _DateField2.default,
	      Tabs: _uiv.Tabs,
	      ClubPicker: _ClubPicker2.default,
	      Tab: _uiv.Tab,
	
	      Sheet: _Sheet2.default,
	      SheetLine: _SheetLine2.default,
	      SheetFunnel: _SheetFunnel2.default,
	
	      Sorter: _Sorter2.default,
	      Funnel: _Funnel2.default,
	      Translation: _Translation2.default
	    }
	  });
	}
	window.mainApp = mainApp;

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      messages: {},
	      ticker: false
	
	    };
	  },
	  created: function created() {
	    this.$on('translation-custom', this.makeTranslation);
	  },
	
	  methods: {
	    trans: function trans(msgId) {
	      var self = this;
	      if (self.messages.hasOwnProperty(msgId)) {
	        return self.messages[msgId];
	      } else {
	        return msgId;
	      }
	    },
	    makeTranslation: function makeTranslation(msgId, msgStr) {
	      var self = this;
	      self.messages[msgId] = msgStr;
	      if (self.ticker) {
	        window.clearTimeout(self.ticker);
	      }
	      self.ticker = window.setTimeout(function (x) {
	        x.$forceUpdate();
	      }, 50, self);
	    }
	  }
	};

/***/ },
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(213),
	  /* template */
	  __webpack_require__(310),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(214),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(215),
	  /* template */
	  __webpack_require__(316),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(217),
	  /* template */
	  null,
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    searchFields: {
	      type: Array,
	      default: function _default() {
	        return ['first_name', 'last_name'];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      searchBox: ''
	    };
	  },
	  methods: {
	    filteredList: function filteredList(collection) {
	      var self = this;
	      var lowSearch = self.searchBox.toLowerCase();
	      var out;
	      if (lowSearch.hasOwnProperty('trim')) {
	        lowSearch = lowSearch.trim();
	      }
	      if (lowSearch.length > 1) {
	        out = _lodash2.default.filter(collection, function (item) {
	          var ss = self.searchStrings[item[self.pk || 'id']];
	          return ss && ss.indexOf(lowSearch) > -1;
	        });
	        return out;
	      } else {
	        return collection;
	      }
	    }
	  },
	  computed: {
	    searchStrings: function searchStrings() {
	      var self = this;
	      var l = self.searchFields.length;
	      var val = '';
	      var _strings = [];
	      self.dataset.forEach(function (obj) {
	        var s = '';
	        var j = 0;
	        for (; j < l; j++) {
	          if (obj.hasOwnProperty('bib') && !obj.hasOwnProperty('sortbib')) {
	            obj.sortbib = isNaN(parseInt(obj.bib)) ? obj.bib : parseInt(obj.bib);
	          }
	          val = obj[self.searchFields[j]];
	          if (typeof val === 'string') {
	            s += val.toLowerCase() + ' ';
	          }
	        }
	        _strings[obj[self.pk]] = s;
	      });
	      return _strings;
	    }
	  }
	};

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	var double = function double(stuff) {
	  return stuff + stuff;
	};
	
	var gettext = function gettext(x) {
	  return x;
	};
	
	var treble = function treble(stuff) {
	  return stuff + stuff + stuff;
	};
	
	
	var sorts = function () {
	  var dd = {
	    JUMPS: ['HJ', 'PV', 'LJ', 'TJ'],
	    THROWS: ['DT', 'JT', 'HT', 'SP', 'WT'],
	    MULTI_EVENTS: ['PEN', 'HEP', 'DEC', 'PENI', 'PENWT'],
	    STANDARD_MALE_TRACK_EVENTS: ['100', '200', '400', '800', '1500', '5000', '10000', '110H', '400H', '3000SC', '4x100', '4x400'],
	
	    FIELD_SORT_ORDER: ['HJ', 'PV', 'LJ', 'TJ', 'SP', 'DT', 'HT', 'JT'],
	    FIELDS: [['30', '60', gettext('60m')], ['40', '100', gettext('100m')], ['50', '200', gettext('200m')], ['70', '400', gettext('400m')], ['90', '800', gettext('800m')], ['100', '1000', gettext('1000m')], ['110', '1500', gettext('1500m')], ['120', 'Mile', gettext('One Mile')], ['140', '3000', gettext('3000m')], ['160', '5000', gettext('5000m')], ['170', '10000', gettext('10,000m')], ['186', '10K', gettext('10km')], ['188', '20K', gettext('20km')], ['190', 'HM', gettext('Half Marathon')], ['200', 'Mar', gettext('Marathon')], ['250', '60H', gettext('60m Hurdles')], ['248', '60H91.4', gettext('60m Hurdles (91.4cm)')], ['251', '60H76.2', gettext('60m Hurdles (76.2cm)')], ['252', '60H100', gettext('60m Hurdles (99cm)')], ['260', '100H', gettext('100m Hurdles')], ['270', '110H', gettext('110m Hurdles')], ['268', '110H91.4', gettext('110m Hurdles (91.4cm)')], ['269', '110H100', gettext('110m Hurdles (99cm)')], ['259', '100H76.2', gettext('100m Hurdles (76.2cm)')], ['300', '400H', gettext('400m Hurdles')], ['299', '400H84', gettext('400m Hurdles (84.0cm)')], ['210', '2000S', gettext('2000m Steeplechase')], ['220', '3000S', gettext('3000m Steeplechase')], ['420', '3000W', gettext('3000m Race Walk')], ['430', '5000W', gettext('5000m Race Walk')], ['440', '10000W', gettext('10,000m Race Walk')], ['450', '20000W', gettext('20,000 m Race Walk')], ['480', '5W', gettext('5km Race Walk')], ['490', '10W', gettext('10km Race Walk')], ['500', '20W', gettext('20km Race Walk')], ['550', '50W', gettext('50km Race Walk')], ['560', '4x1', gettext('4x100m Relay')], ['580', '4x4', gettext('4x400m Relay')], ['612', '4xMED', gettext('Medley Relay')], ['310', 'HJ', gettext('High Jump')], ['320', 'PV', gettext('Pole Vault')], ['330', 'LJ', gettext('Long Jump')], ['340', 'TJ', gettext('Triple Jump')], ['350', 'SP', gettext('Shot Put')], ['345', 'SP3', gettext('Shot Put (3kg)')], ['347', 'SP5', gettext('Shot Put (5kg)')], ['348', 'SP6', gettext('Shot Put (6kg)')], ['360', 'DT', gettext('Discus Throw')], ['358', 'DT1.5', gettext('Discus Throw (1.5kg)')], ['359', 'DT1.75', gettext('Discus Throw (1.75kg)')], ['375', 'HT3', gettext('Hammer Throw (3kg)')], ['377', 'HT5', gettext('Hammer Throw (5kg)')], ['378', 'HT6', gettext('Hammer Throw (6kg)')], ['380', 'HT', gettext('Hammer Throw')], ['390', 'JT', gettext('Javelin Throw')], ['387', 'JT500', gettext('Javelin Throw (500 g)')], ['389', 'JT700', gettext('Javelin Throw (700 g)')], ['399', 'Pen', gettext('Pentathlon')], ['400', 'Hep', gettext('Heptathlon')], ['400', 'Hepi', gettext('Heptathlon (i)')], ['401', 'Hepj', gettext('Heptathlon Girls')], ['410', 'Dec', gettext('Decathlon')], ['411', 'Decj', gettext('Decathlon Junior')], ['412', 'Decy', gettext('Decathlon Boys')], ['700', 'R', gettext('Reserve')], ['802', 'MR', gettext('Mountain Running')], ['40 (extra events)', '100', gettext('B-race 100m')], ['560 (extra events', '4x1', gettext('B-race 4x100m Relay')], ['70 (extra events)', '400', gettext('B-race 400m')]]
	  };
	  dd.FIELD_EVENTS = dd.JUMPS + dd.THROWS;
	  dd.STANDARD_FEMALE_TRACK_EVENTS = dd.STANDARD_MALE_TRACK_EVENTS.map(function (x) {
	    return x === '110H' ? '100H' : x;
	  });
	  return dd;
	}();
	
	function encodeQueryData(data) {
	  var ret = [];
	  for (var d in data) {
	    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
	  }
	  return ret.join('&');
	}
	
	module.exports = { sorts: sorts, double: double, treble: treble, encodeQueryData: encodeQueryData };

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handsontableFull = __webpack_require__(284);
	
	var _handsontableFull2 = _interopRequireDefault(_handsontableFull);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: {
	    data: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    },
	    settings: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.settings.data = this.data;
	    this.table = new _handsontableFull2.default(this.$el, this.settings);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.table.destroy();
	  }
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sign = __webpack_require__(220);
	
	var _sign2 = _interopRequireDefault(_sign);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'closing-date',
	  props: ['cutoff'],
	  computed: {
	    msg: function msg() {
	      var cutoffDate = (0, _moment2.default)(this.cutoff);
	      var today = (0, _moment2.default)();
	      var daysToGo = cutoffDate.diff(today, 'days');
	      var text;
	
	      switch ((0, _sign2.default)(daysToGo)) {
	        case 1:
	          text = '' + daysToGo + ' days to go';
	          break;
	        case 0:
	          text = 'Closing today!';
	          break;
	        case -1:
	          text = 'Closed ' + (0 - daysToGo) + ' days ago';
	          break;
	      }
	
	      return text;
	    }
	  }
	};

/***/ },
/* 205 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'component-one'
	};

/***/ },
/* 206 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'component-two'
	};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TranslationMixin = __webpack_require__(15);
	
	var _TranslationMixin2 = _interopRequireDefault(_TranslationMixin);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pattern = /^(\d{4})-(\d{2})-(\d{2})$/;
	
	var isLeap = function isLeap(y) {
	  return !(y % 4 || !(y % 100) && y % 400);
	};
	
	var isDate = function isDate(value) {
	  var md = new Date(value);
	  return isNaN(md.valueOf()) ? false : md.getFullYear() > 1899;
	};
	
	exports.default = {
	  mixins: [_TranslationMixin2.default],
	  props: {
	    required: {
	      type: Boolean,
	      default: false
	    },
	    name: String,
	    showLabels: Boolean,
	    min: {
	      type: String,
	      default: '1900',
	      validator: isDate
	    },
	    max: {
	      type: String,
	      default: new Date().toISOString().substr(0, 10),
	      validator: isDate
	    },
	    initial: {
	      type: String,
	      validator: isDate,
	      default: function _default() {
	        return new Date().toISOString().substr(0, 10);
	      }
	    },
	    minAge: {
	      type: String,
	      validator: function validator(value) {
	        var v = parseInt(value);
	        return isNaN(v) || v > 1;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      date: {
	        day: '',
	        month: '',
	        year: ''
	      },
	      justFocused: false,
	      maxDate: null,
	      minDate: null
	    };
	  },
	
	  methods: {
	    selectText: function selectText(inputNode) {
	      if (document.body.createTextRange) {
	        var range = document.body.createTextRange();
	        range.moveToElementText(inputNode);
	        range.select();
	      } else {
	        if (window.getSelection) {
	          var selection = window.getSelection();
	          selection.removeAllRanges();
	          inputNode.setSelectionRange(0, inputNode.value.length);
	        } else {
	          console.warn('Could not select text in node: Unsupported browser.');
	        }
	      }
	    },
	    highlight: function highlight(ev) {
	      var self = this;
	      var target = ev.target;
	      if (target.value.length) {
	        self.selectText(target);
	      }
	      self.justFocused = true;
	    },
	    controlDigits: function controlDigits(event, keyDown) {
	      var self = this;
	      var i = event.target;
	      var cn = i.className;
	      var next = '';
	      var nextClass = '';
	      var ln = cn.indexOf('year') > 0 ? 4 : 2;
	      var sel = window.getSelection();
	      var selObj = null;
	      if (sel.toString().length) {
	        selObj = sel.anchorNode.childNodes[sel.anchorOffset];
	        if (selObj === i && keyDown && '0123456789'.indexOf(event.key) !== -1) {
	          event.target.value = event.target.value.replace(sel.toString(), '');
	        }
	      }
	      if (event.key.length === 1 && '0123456789'.indexOf(event.key) === -1) {
	        event.preventDefault();
	        return false;
	      } else {
	        if (event.key.length === 1 && '0123456789'.indexOf(event.key) !== -1 && event.target.value.length === ln) {
	          if (ln === 2 && !self.justFocused) {
	            nextClass = cn.indexOf('month') > 0 ? 'year' : 'month';
	            next = self.$el.getElementsByClassName(nextClass)[0];
	            next.focus();
	          }
	        }
	      }
	      if (!keyDown) {
	        self.justFocused = false;
	      }
	    },
	    doneDigits: function doneDigits(e) {
	      _lodash2.default.debounce(this.controlDigits, 150)(e, false);
	    },
	    digitsOnly: function digitsOnly(e) {
	      _lodash2.default.debounce(this.controlDigits, 150)(e, true);
	    },
	    dateObj: function dateObj(a) {
	      var attrs = ['year', 'month', 'day'];
	      var ints = pattern.exec(a);
	      if (!ints) {
	        return {};
	      }
	      ints.shift();
	      return ints.reduce(function (obj, val, i) {
	        obj[attrs[i]] = parseInt(val);
	        return obj;
	      }, {});
	    },
	    isoDate: function isoDate() {
	      var self = this;
	      var d = self.date;
	
	      return d.year ? new Date(d.year, d.month - 1, d.day) : null;
	    },
	    assertValidDate: function assertValidDate() {
	      var self = this;
	      var d = arguments.length > 0 ? self.dateObj(arguments[0]) : self.date;
	      var jsDate = self.isoDate();
	      var valid = true;
	      if (!d.day && !d.month && !d.year) {
	        return true;
	      } else {
	        valid = d.day && d.month && d.year && jsDate;
	        if (valid) {
	          valid = jsDate >= self.minDate && jsDate <= self.maxDate && d.month < 13;
	        }
	        if (valid) {
	          if (d.month === 2) {
	            valid = isLeap(d.year) ? d.day < 30 : d.day < 29;
	          } else {
	            valid = [4, 6, 9, 11].indexOf(d.month) > -1 && d.day < 31 || d.day < 32;
	          }
	        }
	        return valid;
	      }
	    },
	    pad: function pad(n, width, z) {
	      z = z || '0';
	      n = n + '';
	      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	    },
	    isoString: function isoString() {
	      var self = this;
	      var d = self.date.day;
	      var m = self.date.month;
	      var y = self.date.year;
	      return self.date.year && self.assertValidDate() ? y + '-' + self.pad(m, 2) + '-' + self.pad(d, 2) : '';
	    }
	  },
	  computed: {
	    isValidDate: function isValidDate() {
	      return this.assertValidDate();
	    }
	  },
	  created: function created() {
	    var self = this;
	    self.maxDate = self.max ? new Date(self.max) : new Date();
	    self.minDate = new Date(self.min);
	    if (self.initial) {
	      self.date = self.dateObj(self.initial);
	    }
	  }
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueHandsontable = __webpack_require__(304);
	
	var _vueHandsontable2 = _interopRequireDefault(_vueHandsontable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultColumns = [{ data: 'first_name' }, { data: 'last_name' }, { data: 'date_of_birth', 'type': 'date' }, { data: 'gender', 'type': 'dropdown', 'source': ['M', 'F'] }];
	
	exports.default = {
	  components: {
	    Handsontable: _vueHandsontable2.default
	  },
	  props: {
	    grid: String,
	    columns: String,
	    reg_num: false,
	    categories: String
	  },
	  methods: {
	    toTitleCase: function toTitleCase(str) {
	      return str.replace(/\w\S*/g, function (txt) {
	        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	      });
	    },
	    colHeaders: function colHeaders(colz) {
	      var self = this;
	      var o = colz.map(function (i) {
	        return self.toTitleCase(i.data.split('_').join(' '));
	      });
	      return o;
	    }
	  },
	  data: function data() {
	    var cols = defaultColumns;
	    var catColumn = {};
	    var cats = null;
	    if (this.reg_num) {
	      cols.unshift({ data: 'reg_num', type: 'numeric' });
	    }
	    if (this.categories) {
	      cats = JSON.parse(this.categories);
	      catColumn = { data: 'category' };
	      if (typeof cats !== 'boolean') {
	        catColumn.type = 'dropdown';
	        catColumn.source = cats;
	      }
	      cols.push(catColumn);
	    }
	    var setts = {};
	    if (typeof this.grid !== 'undefined') {
	      setts = { data: JSON.parse(this.grid), settings: {} };
	    } else {
	      setts = {
	        settings: { columns: cols, colHeaders: this.colHeaders(cols), minSpareRows: 2 },
	        data: []
	      };
	    }
	    return setts;
	  }
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(40);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(41);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    list: Array,
	    keyName: String,
	    competitors: {
	      type: Array,
	      default: []
	    },
	    classes: String,
	    btn_classes: String,
	    valMap: Object
	  },
	  data: function data() {
	    return {
	      keySet: [],
	      unranked: false,
	      selected: []
	    };
	  },
	  methods: {
	    toggle: function toggle(itm, ev) {
	      var self = this;
	      var idx = self.selected.indexOf(itm);
	      if (idx >= 0) {
	        self.selected.splice(idx, 1);
	      } else {
	        self.selected.push(itm);
	      }
	      self.$emit('filtered', self);
	      ev.target.parentNode.parentNode.scrollTo(0, 0);
	    },
	    reset: function reset() {
	      this.selected = [];
	      this.$emit('filtered', this);
	    },
	    compar: function compar(a, b) {
	      var self = this;
	      if (self.selected.indexOf(a) >= 0) {
	        return -1;
	      } else {
	        if (self.selected.indexOf(b) >= 0) {
	          return 1;
	        } else {
	          if (a > b) {
	            return 1;
	          } else {
	            if (a < b) {
	              return -1;
	            } else {
	              return 0;
	            }
	          }
	        }
	      }
	    }
	  },
	  computed: {
	    univers: function univers() {
	      var self = this;
	      if (self.keySet.length) {
	        return self.keySet.sort(self.compar);
	      } else {
	        return [];
	      }
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    var listKeys = self.list.length ? (0, _keys2.default)(self.list[0]) : [];
	    var keySet = [];
	    if (listKeys.indexOf(self.keyName) >= 0) {
	      keySet = _lodash2.default.map(self.list, function (l) {
	        var val = l[self.keyName] !== '' ? l[self.keyName] : '<blank>';
	        if (self.valMap) {
	          if (self.valMap[l[self.keyName]]) {
	            val = self.valMap[l[self.keyName]];
	          }
	        }
	        return val;
	      });
	    } else if (self.keyName.includes('.')) {
	      var nestedObjKeys = self.keyName.split('.');
	      keySet = _lodash2.default.map(self.list, function (l) {
	        var nestedObjs = [];
	        var val = null;
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(nestedObjKeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            var i = nestedObjKeys.indexOf(key);
	            if (i === 0) {
	              nestedObjs.push(l[key]);
	            } else if (nestedObjKeys.length - 1 === i) {
	              console.log(nestedObjs, i);
	              val = nestedObjs[i - 1][key];
	            } else {
	              nestedObjs.push(nestedObjs[i][key]);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return val;
	      });
	    } else if (self.competitors.length) {
	      keySet = _lodash2.default.map(self.competitors, function (uc) {
	        return uc[self.keyName];
	      });
	    }
	    self.keySet = _lodash2.default.uniq(keySet);
	    if ((0, _keys2.default)(this.$parent.filterMapping).length) {
	      console.log(this.$parent.filterMapping[this.keyName]);
	      this.selected = this.$parent.filterMapping[this.keyName];
	    }
	  }
	};

/***/ },
/* 210 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    msgid: String,
	    msgstr: String
	  },
	  created: function created() {
	    var self = this;
	    self.$parent.$emit('translation-custom', self.msgid, self.msgstr);
	  }
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(42);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(202);
	
	var _TranslationMixin = __webpack_require__(15);
	
	var _TranslationMixin2 = _interopRequireDefault(_TranslationMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_TranslationMixin2.default],
	  props: {
	    indoor: {
	      type: String,
	      default: '0'
	    },
	    isAdmin: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    },
	    forceVisible: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    },
	    year: {
	      type: String,
	      validator: function validator(value) {
	        if (isNaN(parseInt(value))) {
	          return value === 'ALLT';
	        } else {
	          var v = parseInt(value);
	          return v > 1900 && v <= new Date().getFullYear();
	        }
	      }
	    },
	    country: {
	      type: String,
	      validator: function validator(value) {
	        return value.length === 3 || value.length === 2;
	      },
	      default: 'EST'
	    },
	    version: {
	      type: Number,
	      default: 1
	    },
	    showDob: {
	      type: Number,
	      default: 0
	    },
	    tilastopajaDomain: {
	      type: String
	    },
	    gender: {
	      type: String,
	      validator: function validator(value) {
	        return ['W', 'M'].indexOf(value.toUpperCase()) >= 0;
	      },
	      default: 'M'
	    },
	    agegroup: {
	      type: String,
	      default: 'SEN'
	    },
	    event: String,
	    periods: { type: Array, default: function _default() {
	        return [['ALLT', 'all time'], ['2018'], ['2017']];
	      } },
	    ageGroups: { type: Array, default: function _default() {
	        return [['SEN', 'Senior'], ['U23'], ['U20'], ['U18'], ['U16'], ['U14']];
	      } }
	  },
	  data: function data() {
	    return {
	      genders: [],
	      dataYear: new Date().getFullYear() + '',
	      dataEvent: '',
	      dataAgeGroup: '',
	      dataCountry: '',
	      dataGender: '',
	      dataIndoor: '0',
	      est_date_pattern: /\d{2}\.\d{2}\.\d{4}/,
	      rankings: [],
	      eventCodes: [],
	      dummy: '',
	      sortKey: '',
	      sortWays: [],
	      sortKeys: [],
	      tilpa: {},
	      current: {},
	      goodResponse: false,
	      error: null,
	      messages: {},
	      jsonUrl: '',
	      isSmallSearchVisible: false,
	      loadingState: false,
	      currentAthleteId: '',
	      jsonUrlEvents: ''
	    };
	  },
	
	  methods: {
	    showBirth: function showBirth(dateString) {
	      var self = this;
	      if (self.showDob === 1) {
	        return new Date(dateString).toLocaleDateString();
	      } else {
	        return dateString.slice(0, 4);
	      }
	    },
	    formattedPerformances: function formattedPerformances(perfs) {
	      var out = [];
	      _lodash2.default.each(perfs.split(' '), function (p) {
	        var splt = p.split('/');
	        var row = { value: splt[0] };
	        if (splt.length > 1) {
	          row.wind = splt[1];
	        }
	        out.push(row);
	      });
	      return out;
	    },
	    floatSort: function floatSort(obj) {
	      if (obj.result) {
	        obj.result_num = parseFloat(obj.result);
	      } else {
	        obj.result_num = 0;
	      }
	      if (obj.rank) {
	        obj.rank_num = parseFloat(obj.rank);
	      } else {
	        obj.rank_num = 0;
	      }
	    },
	    obj2EC: function obj2EC(obj) {
	      return [obj.eventCode, obj.event, obj.eventName];
	    },
	    populateState: function populateState() {
	      var s = this;
	      var r = {
	        gender: s.dataGender === 'W' ? s.trans('Women') : s.trans('Men'),
	        year: s.dataYear,
	        country: s.country,
	        indoor: s.dataIndoor === '1' ? s.trans('Indoor') : s.trans('Outdoor'),
	        agegroup: s.dataAgeGroup
	      };
	      try {
	        r.event = _lodash2.default.find(_utils.sorts.FIELDS, function (row) {
	          return row[0] === s.dataEvent;
	        })[2];
	      } catch (e) {}
	      return r;
	    },
	    windy: function windy(wind) {
	      return parseFloat(wind) > 2.0;
	    },
	    formatWind: function formatWind(wind) {
	      var includePlus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      wind = wind.replace('++', '');
	      wind = wind.replace('+', '');
	
	      if (includePlus && parseFloat(wind) > 0) wind = '+' + wind;
	
	      return wind;
	    },
	    setCurrent: function setCurrent() {
	      var self = this;
	      var url = '';
	      self.current = self.populateState();
	      if (!self.loadingState) {
	        url = self.directUrl().substr(self.directUrl().indexOf('/ranking/'));
	        window.history.pushState(self.getCurrent(), self.current.country + ' ' + self.current.year + ' ' + self.current.event + ' ' + self.current.indoor + ' ' + self.current.gender, url);
	      } else {
	        self.loadingState = false;
	      }
	      self.isSmallSearchVisible = false;
	    },
	    isSameFilterSet: function isSameFilterSet() {
	      var self = this;
	      var t = self.populateState();
	      var c = self.current;
	      var F = ['event', 'country', 'year', 'gender', 'agegroup', 'indoor'];
	      var f;
	      for (var i = 0; i < F.length; i++) {
	        f = F[i];
	        if (c[f] !== t[f]) return false;
	      }
	      return true;
	    },
	    eventsUrl: function eventsUrl() {
	      var self = this;
	      var q = { gender: self.dataGender, season: self.dataYear.toLowerCase(), ag: self.dataAgeGroup.toUpperCase(), country: self.country.toLowerCase(), ind: self.dataIndoor };
	      var url = '//' + self.tilastopajaDomain + '/json/eventsAPI.php';
	      if (q.ag === 'SEN') delete q.ag;
	      return url + '?' + (0, _utils.encodeQueryData)(q);
	    },
	    loadEvents: function loadEvents(cb) {
	      var self = this;
	      if (self.state >= 1) {
	        var url = self.eventsUrl();
	        self.jsonUrlEvents = '';
	        self.$http.get(url, {}).then(function (response) {
	          self.dummy = 'raw data';
	          return response.json();
	        }).then(function (data) {
	          self.dummy = 'json data';
	          data = self.cleanTilpaData(data);
	          if (!Array.isArray(data)) data = [data];
	          self.eventCodes = [];
	          data.forEach(function (d) {
	            var events = d.hasOwnProperty('events') ? d.events.map(self.obj2EC) : [];
	            events.forEach(function (ev) {
	              self.eventCodes.push(ev);
	            });
	          });
	          if (self.eventCodes.length >= 1) {
	            self.dataEvent = self.eventCodes[0][0];
	            self.error = null;
	            if (cb) {
	              cb();
	            }
	          } else {
	            self.error = 'No events were seen in the data';
	          }
	          self.jsonUrlEvents = url;
	        }).catch(function (error) {
	          self.error = error;
	          self.eventCodes = [];
	        });
	      }
	    },
	    rankingsUrl: function rankingsUrl() {
	      var self = this;
	      var url;
	      var q = { gender: self.dataGender, season: self.dataYear.toLowerCase(), ind: self.dataIndoor, event: self.dataEvent, ag: self.dataAgeGroup.toUpperCase(), country: self.country.toLowerCase() };
	      if (q.ag === 'SEN') {
	        delete q.ag;
	      }
	      url = '//' + self.tilastopajaDomain + '/json/listApi.php';
	      return url + '?' + (0, _utils.encodeQueryData)(q);
	    },
	    loadRankings: function loadRankings() {
	      var self = this;
	      if (self.state === 2) {
	        var url = self.rankingsUrl();
	        self.jsonUrl = '';
	        self.$http.get(url, {}).then(function (response) {
	          self.dummy = 'raw data';
	          return response.json();
	        }).then(function (data) {
	          self.dummy = 'json data';
	          data = self.cleanTilpaData(data);
	          self.tilpa = data;
	          if (data.hasOwnProperty('ranking')) {
	            self.rankings = data.ranking;
	            _lodash2.default.each(self.rankings, self.floatSort);
	          }
	          self.jsonUrl = url;
	          self.goodResponse = true;
	          self.error = null;
	          self.setCurrent();
	        }).catch(function (error) {
	          self.error = error;
	          self.goodResponse = false;
	        });
	      }
	    },
	    loadTilastopaja: function loadTilastopaja(cb) {
	      var self = this;
	      if (self.state === 1) {
	        self.loadEvents(cb);
	      } else if (self.state === 2) {
	        self.loadRankings();
	      }
	    },
	    cleanTilpaData: function cleanTilpaData(obj, keysToRename) {
	      if (typeof keysToRename === 'undefined') {
	        keysToRename = {};
	      }
	      var isArray = Array.isArray;
	
	      function cleanObject(o) {
	        var build, key, destKey, value;
	        build = {};
	        for (key in o) {
	          destKey = keysToRename[key] || key;
	          value = o[key];
	          if (value === null) {
	            value = '';
	          } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
	            value = isArray(value) ? value.map(cleanObject) : cleanObject(value);
	          }
	          build[destKey] = value;
	        }
	        return build;
	      }
	      return isArray(obj) ? obj.map(cleanObject) : cleanObject(obj);
	    },
	    cfilter: function cfilter(e, n) {
	      var self = this;
	      if (!n) {
	        var sev = e.target.form.event;
	        if (sev) {
	          sev.selectedIndex = -1;
	          sev.value = '';
	        }
	        self.dataEvent = '';
	        self.eventCodes = [];
	        self.jsonUrl = '';
	        self.jsonUrlEvents = '';
	      }
	    },
	    table_opacity: function table_opacity() {
	      var self = this;
	      return self.isSameFilterSet() ? '1.0' : '0.5';
	    },
	    getCurrent: function getCurrent() {
	      var self = this;
	      return {
	        gender: self.dataGender,
	        agegroup: self.dataAgeGroup,
	        year: self.dataYear,
	        indoor: self.dataIndoor,
	        event: self.dataEvent
	      };
	    },
	    directUrl: function directUrl() {
	      var self = this;
	      var u = [window.location.protocol, '//', window.location.host, window.location.pathname].join('');
	      return u + '?' + (0, _utils.encodeQueryData)(self.getCurrent());
	    },
	    personHref: function personHref(p) {
	      return (p.otAthleteId ? '/people/' + p.otAthleteId : '/person_tilpa/' + p.tpAthleteId) + '/';
	    },
	    loadState: function loadState(src) {
	      var self = this;
	      if (src.year) self.dataYear = src.year;
	      if (src.country) self.dataCountry = src.country;
	      if (src.gender) self.dataGender = src.gender.toUpperCase();
	      if (src.agegroup) self.dataAgeGroup = src.agegroup;
	      if (src.indoor) self.dataIndoor = src.indoor === '1' ? '1' : '0';
	      if (src.event) {
	        self.loadTilastopaja(function () {
	          for (var i = 0; i < self.eventCodes.length; i++) {
	            if (self.eventCodes[i][0] === src.event) {
	              self.dataEvent = src.event;
	              self.loadTilastopaja();
	              return;
	            }
	          }
	        });
	      }
	    }
	  },
	  computed: {
	    sortedRankings: function sortedRankings() {
	      var self = this;
	      return self.sortedList(self.rankings, self.sortKeys);
	    },
	    expandedRankings: function expandedRankings() {
	      var self = this;
	      var out = [];
	      _lodash2.default.each(self.rankings, function (r) {
	        var row2 = {};
	        if (r.hasOwnProperty('combinedPerformances')) {
	          if (r.combinedPerformances.trim().length > 0) {
	            row2 = { combinedPerformances: r.combinedPerformances };
	          }
	          delete r.combinedPerformances;
	        }
	        out.push(r);
	        if (row2) {
	          out.push(row2);
	        }
	      });
	      return out;
	    },
	    state: function state() {
	      var self = this;
	      var s = 0;
	      if (self.dataGender && self.dataCountry && self.dataAgeGroup && self.dataYear && self.dataIndoor && self.dataEvent) s = 2;else if (self.dataGender && self.dataCountry && self.dataAgeGroup && self.dataYear && self.dataIndoor) s = 1;
	      return s;
	    },
	    errorMessage: function errorMessage() {
	      var self = this;
	      var msg = '';
	      if (self.error) {
	        if (self.error.statusText) {
	          msg = self.error.statusText;
	        } else {
	          msg = self.error.toString();
	          if (msg.indexOf('SyntaxError') > -1) {
	            msg = self.trans('Error processing data!');
	          }
	        }
	        return '! ' + msg;
	      } else {
	        return '';
	      }
	    }
	  },
	  created: function created() {
	    var self = this;
	    self.loadState(self);
	    if (self.forceVisible) self.isSmallSearchVisible = true;
	    window.onpopstate = function (e) {
	      self.loadingState = true;
	      self.state = 2;
	      if (window.history.state) self.loadState(window.history.state);
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.genders = [{ value: 'M', text: self.trans('Men') }, { value: 'W', text: self.trans('Women') }];
	  }
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(41);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _jquery = __webpack_require__(285);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _TranslationMixin = __webpack_require__(15);
	
	var _TranslationMixin2 = _interopRequireDefault(_TranslationMixin);
	
	var _SearchMixin = __webpack_require__(201);
	
	var _SearchMixin2 = _interopRequireDefault(_SearchMixin);
	
	var _Translation = __webpack_require__(197);
	
	var _Translation2 = _interopRequireDefault(_Translation);
	
	var _SheetFunnel = __webpack_require__(194);
	
	var _SheetFunnel2 = _interopRequireDefault(_SheetFunnel);
	
	var _SheetLine = __webpack_require__(195);
	
	var _SheetLine2 = _interopRequireDefault(_SheetLine);
	
	var _Sorter = __webpack_require__(196);
	
	var _Sorter2 = _interopRequireDefault(_Sorter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  delimiters: ['${', '}'],
	  mixins: [_SearchMixin2.default, _TranslationMixin2.default],
	  components: [_Translation2.default, _Sorter2.default, _SheetLine2.default, _SheetFunnel2.default],
	  props: {
	    dataset: Array,
	    pk: String,
	    relatedDataset: Array,
	    relatedFk: String,
	    ajax: Boolean,
	    baseUrl: String,
	    resultsPerPage: {
	      type: Number,
	      default: function _default() {
	        return 50;
	      }
	    },
	    numPages: Number,
	    total: Number,
	    downloads: Array
	  },
	  data: function data() {
	    return {
	      headings: [],
	      sortKey: '',
	      sortWays: [],
	      sortKeys: [],
	      filterMapping: {},
	      page: 0
	    };
	  },
	  watch: {
	    page: function page(val) {
	      this.tooltipEmAll();
	    }
	  },
	  methods: {
	    safeFlag: function safeFlag(rw, flagKey) {
	      var flag = '';
	      if (rw && rw.hasOwnProperty(flagKey) || rw && rw.hasOwnProperty('flag_url')) {
	        flag = rw[flagKey] || '';
	        if (flag !== '') {
	          if (flag.length > 0 && flag.indexOf("'") > 0) {
	            flag = flag.replace("'", "\\'");
	          }
	        }
	      }
	
	      return flag;
	    },
	    tooltipEmAll: function tooltipEmAll(tm) {
	      var self = this;
	      window.setTimeout(function (elf) {
	        elf.find('[title]').tooltip();
	      }, tm || 500, (0, _jquery2.default)(self.$el));
	    },
	    setPg: function setPg(p) {
	      if (this.$parent.setPg) {
	        this.$parent.setPg(p);
	      }
	      this.page = p;
	    },
	    mvPg: function mvPg(i) {
	      if (this.$parent.mvPg) {
	        this.$parent.mvPg(i);
	      }
	      this.page += i;
	    },
	    tdClass: function tdClass(header) {
	      var s = '';
	      if (header.flag) {
	        s += 'flg ';
	      }
	      if (header.class) {
	        s += header.class;
	      }
	      if (header.$vnode.elm.className) {
	        s += header.$vnode.elm.className;
	      }
	      return s;
	    },
	    sortBy: function sortBy(ref) {
	      var self = this;
	      var sortKey = ref.keyName;
	      var dir = ref.direction;
	      var found = self.sortKeys.indexOf(sortKey);
	      if (found > -1) {
	        if (found === 0) {
	          dir = dir || (self.sortWays[found] === 'asc' ? 'desc' : 'asc');
	          self.sortWays[found] = dir;
	        } else {
	          self.sortKeys.splice(found, 1);
	          self.sortWays.splice(found, 1);
	
	          self.sortKeys.unshift(sortKey);
	          self.sortWays.unshift(dir || 'asc');
	        }
	      } else {
	        self.sortKeys.unshift(sortKey);
	        self.sortWays.unshift(dir || 'asc');
	      }
	      self.sortKey = sortKey;
	      self.sortWays = self.sortWays.slice(0, self.sortWays.length);
	    },
	    resetSort: function resetSort() {
	      var self = this;
	      self.sortKeys = [];
	      self.sortWays = [];
	      self.sortKey = '';
	      self.$children.forEach(function (a, idx) {
	        if (a.direction) {
	          a.direction = '';
	        }
	      });
	    },
	    refilter: function refilter(ref) {
	      var self = this;
	      var key = ref.keyName || ref.keyFunc;
	      if (ref.selected.length) {
	        self.filterMapping[key] = ref.selected;
	      } else {
	        if (self.filterMapping[key].indexOf(key)) {
	          delete self.filterMapping[key];
	        }
	      }
	      self.$forceUpdate();
	    },
	    invoke: function invoke(param, row, header, i) {
	      var self = this;
	      var out, h;
	      if (typeof param === 'undefined') {
	        return '';
	      } else {
	        h = header.idx != null ? header.idx : i;
	        if (self.$parent[param]) {
	          out = self.$parent[param](row, h, header);
	        }
	        return out || '';
	      }
	    },
	    isDialog: function isDialog(param, row, header, i) {
	      var self = this;
	      var xtra = self.invoke(header.lightbox, row, header, i);
	      return xtra.isDialog;
	    },
	    openLightbox: function openLightbox(row, header, i) {
	      var self = this;
	      var xtra = self.invoke(header.lightbox, row, header, i);
	      var placeholder, src;
	      if (!(0, _jquery2.default)('#lightBox').length) {
	        placeholder = '<div class="modal fade" id="lightBox" tabindex="-1" role="dialog" aria-labelledby="lightBoxTitle" aria-hidden="true">' + '<div class="modal-dialog" role="document">' + '  <div class="modal-content">' + '    <div class="modal-header">' + '      <button type="button" class="close pull-right float-right" data-dismiss="modal" aria-label="trans(\'close\')">' + '       <span aria-hidden="true">&times;</span>' + '      </button>' + '      <h4 class="modal-title" id="lightBoxTitle">' + (xtra.title || '') + '</h4>' + '    </div>' + '   <div class="modal-body" style="height: 430px">' + '         <iframe height="400" width="100%" src="/x/blank.html" allowtransparency="true" frameborder="0" style="border: 0 none"></iframe>' + '   </div></div></div>';
	        (0, _jquery2.default)('body').append(placeholder);
	      } else {
	        (0, _jquery2.default)('#lightBox').find('#lightBoxTitle').text(xtra.title || '');
	      }
	      if (xtra.url.toLowerCase().trim().indexOf('<iframe') === 0) {
	        src = (0, _jquery2.default)(xtra.url)[0].src;
	      } else {
	        src = xtra.url;
	      }
	      (0, _jquery2.default)('#lightBox').find('iframe').attr('src', src);
	      (0, _jquery2.default)('#lightBox').modal('show');
	    },
	    loadHeading: function loadHeading(heading) {
	      this.headings.push(heading);
	    },
	    funneledResults: function funneledResults() {
	      var self = this;
	      var results = self.sortedDataset;
	      var func, startIdx;
	      if ((0, _keys2.default)(self.filterMapping).length) {
	        for (var f in self.filterMapping) {
	          if (self.$parent.hasOwnProperty(f)) {
	            func = self.$parent[f];
	            results = _lodash2.default.filter(results, function (r) {
	              return self.filterMapping[f].indexOf(func(r)) >= 0;
	            });
	          } else {
	            if (self.dataKeys.indexOf(f) >= 0) {
	              results = _lodash2.default.filter(results, function (r) {
	                return self.filterMapping[f].indexOf(r[f]) >= 0;
	              });
	            }
	          }
	        }
	      }
	      if (self.resultsPerPage) {
	        startIdx = self.getPageIdx(results);
	        if (results) {
	          return results.slice(startIdx, startIdx + self.resultsPerPage);
	        }
	        return [];
	      } else {
	        return results;
	      }
	    },
	    getColNames: function getColNames(dataset) {
	      if (dataset.length) {
	        return (0, _keys2.default)(dataset[0]);
	      } else {
	        return [];
	      }
	    },
	    orderedList: function orderedList() {
	      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var self = this;
	      var i = 0;
	      var keys = collection.length > 0 ? (0, _keys2.default)(collection[0]) : [];
	
	      for (; i < self.sortKeys.length; i++) {
	        if (keys.indexOf(self.sortKeys[i]) < 0) {
	          self.sortKeys.splice(i, 1);
	          self.sortWays.splice(i, 1);
	        }
	      }
	      if (self.sortKeys.length) {
	        return _lodash2.default.orderBy(collection, self.sortKeys, self.sortWays);
	      } else {
	        return collection;
	      }
	    },
	    getPageIdx: function getPageIdx() {
	      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var self = this;
	      var idx = self.page * self.resultsPerPage;
	      if (res.length < idx) {
	        self.page = 0;
	        idx = 0;
	      }
	      return idx;
	    },
	    arrayFilter: function arrayFilter(row, header, i) {
	      if (row[header.datasetField]) {
	        var dataset = row[header.datasetField].find(header.filter);
	        if (dataset) {
	          return dataset[header.val];
	        }
	      }
	    }
	  },
	  computed: {
	    filteredDataset: function filteredDataset() {
	      var self = this;
	      var dataset = self.dataset.slice();
	      if (self.searchBox.trim().length > 1) {
	        dataset = self.filteredList(dataset);
	      }
	
	      if (self.ajax && !dataset.length) {
	        return self.dataset.slice();
	      }
	      return dataset;
	    },
	    sortedDataset: function sortedDataset() {
	      var self = this;
	      var dataset = self.filteredDataset;
	      if (self.relatedFk) {
	        dataset.forEach(function (d) {
	          var related = _lodash2.default.find(self.relatedDataset, function (rd) {
	            return rd[self.relatedFk] === d[self.pk];
	          }) || {};
	          var keys = (0, _keys2.default)(d);
	          var rk;
	          for (rk in related) {
	            if (keys.indexOf(rk) < 0) {
	              d[rk] = related[rk];
	            }
	          }
	        });
	      }
	      if (self.sortKeys.length > 0) {
	        return self.orderedList(dataset);
	      } else {
	        return dataset;
	      }
	    },
	    dataKeys: function dataKeys() {
	      return _lodash2.default.filter(_lodash2.default.map(this.headings, function (h) {
	        return h.val || null;
	      }), function (m) {
	        return m != null;
	      });
	    },
	    colNames: function colNames() {
	      return this.getColNames(this.dataset);
	    },
	    relatedColNames: function relatedColNames() {
	      return this.getColNames(this.relatedDataset || []);
	    },
	    isLoadingRemaining: function isLoadingRemaining() {
	      return this.$root.isLoadingRemaining;
	    }
	  }
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  delimiters: ['${', '}'],
	  props: {
	    keyFunc: String,
	    keyName: String
	  },
	  data: function data() {
	    return {
	      selected: []
	    };
	  },
	  methods: {
	    toggle: function toggle(itm, ev) {
	      var self = this;
	      var idx = self.selected.indexOf(itm);
	      if (idx >= 0) {
	        self.selected.splice(idx, 1);
	      } else {
	        self.selected.push(itm);
	      }
	      self.$emit('filtered', self);
	      ev.target.parentNode.parentNode.scrollTo(0, 0);
	      self.$nextTick(function () {
	        self.$parent.$forceUpdate();
	      });
	    },
	    reset: function reset() {
	      var self = this;
	      self.selected = [];
	      self.$emit('filtered', self);
	    },
	    compar: function compar(a, b) {
	      var self = this;
	      if (self.selected.indexOf(a) >= 0) {
	        return -1;
	      } else {
	        if (self.selected.indexOf(b) >= 0) {
	          return 1;
	        } else {
	          if (a > b) {
	            return 1;
	          } else {
	            if (a < b) {
	              return -1;
	            } else {
	              return 0;
	            }
	          }
	        }
	      }
	    }
	  },
	  computed: {
	    dataset: function dataset() {
	      var self = this;
	      var sheet = self.$parent;
	      return self.keyFunc || sheet.colNames.indexOf(self.keyName) >= 0 ? sheet.sortedDataset : sheet.sortedRelatedDataset;
	    },
	    options: function options() {
	      var self = this;
	      var sheet = self.$parent;
	      var opts, func;
	      if (self.keyName) {
	        opts = _lodash2.default.uniq(_lodash2.default.map(self.dataset, function (d) {
	          return d[self.keyName];
	        }));
	      } else {
	        func = sheet.$parent[self.keyFunc];
	        opts = _lodash2.default.uniq(_lodash2.default.map(self.dataset, function (d) {
	          return func(d);
	        }));
	      }
	
	      return opts.sort(self.compar);
	    }
	  }
	};

/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  delimiters: ['${', '}'],
	  template: '<span style="display: none"><slot></slot></span>',
	  props: {
	    link: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    },
	    funnel: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    },
	    order: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    },
	    val: String,
	    relatedVal: String,
	    lookup: String,
	    relatedLookup: String,
	    flag: String,
	    extraVal: String,
	    action: String,
	    extraLookup: String,
	    innerClass: String,
	    lightbox: String,
	
	    class: String,
	    tooltip: String,
	    idx: Number,
	    cols: Array,
	    filter: Function,
	    datasetField: Array
	  },
	  created: function created() {
	    this.$parent.loadHeading(this);
	  }
	};

/***/ },
/* 215 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  delimiters: ['${', '}'],
	  props: {
	    keyName: String
	  },
	  data: function data() {
	    return {
	      direction: ''
	    };
	  },
	  methods: {
	    reset: function reset(itm, ev) {
	      var self = this;
	      self.$emit('reset');
	      self.$nextTick(function () {
	        self.$parent.$forceUpdate();
	      });
	    },
	    toggle: function toggle(itm, ev) {
	      var self = this;
	      self.direction = self.direction === 'asc' ? 'desc' : 'asc';
	      self.$emit('sort', self);
	      self.$nextTick(function () {
	        self.$parent.$forceUpdate();
	      });
	    }
	  }
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(40);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _values = __webpack_require__(221);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _typeof2 = __webpack_require__(42);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _athlib = __webpack_require__(200);
	
	var _TranslationMixin = __webpack_require__(15);
	
	var _TranslationMixin2 = _interopRequireDefault(_TranslationMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_TranslationMixin2.default],
	  props: {
	    url: String,
	    showName: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      est_date_pattern: /\d{2}\.\d{2}\.\d{4}/,
	      seasonBests: [],
	      personalBests: [],
	      results: [],
	      dummy: '',
	      tilpa: {} };
	  },
	
	  methods: {
	    highlight: function highlight(e) {
	      var t = e.target;
	      var link = document.getElementsByName(t.href.split('#')[1])[0];
	      var currs = document.getElementsByClassName('backYellow');
	      if (currs.length) {
	        currs[0].className = '';
	      }
	      link.parentNode.parentNode.className = 'backYellow';
	      window.setTimeout(function () {
	        window.scrollBy(0, -150);
	      }, 250);
	    },
	    floatSort: function floatSort(obj) {
	      if (obj.result) {
	        obj.result_num = parseFloat(obj.result);
	      } else {
	        obj.result_num = 0;
	      }
	      if (obj.rank) {
	        obj.rank_num = parseFloat(obj.rank);
	      } else {
	        obj.rank_num = 0;
	      }
	    },
	    addEventSortKey: function addEventSortKey(obj) {
	      if (obj.event) {
	        obj.eventKey = (0, _athlib.textDisciplineSortKey)(obj.event);
	      }
	    },
	    loadTilastopaja: function loadTilastopaja() {
	      var self = this;
	      self.$http.get(self.url, {}).then(function (response) {
	        self.dummy = 'raw data';
	        return response.json();
	      }).then(function (data) {
	        self.dummy = 'json data';
	        data = self.cleanTilpaData(data);
	        self.tilpa = data;
	        if (data.hasOwnProperty('seasonbests')) {
	          self.seasonBests = data.seasonbests;
	          _lodash2.default.each(self.seasonBests, self.floatSort);
	          _lodash2.default.each(self.seasonBests, self.addEventSortKey);
	        }
	        if (data.hasOwnProperty('results')) {
	          self.results = _lodash2.default.values(data.results);
	          for (var i = 0; i < self.results.length; i++) {
	            self.results[i].id = i;
	          }
	          _lodash2.default.each(self.results, self.floatSort);
	          _lodash2.default.each(self.results, self.addEventSortKey);
	        }
	        if (data.hasOwnProperty('personalbests')) {
	          self.personalBests = data.personalbests;
	          _lodash2.default.each(self.personalBests, self.floatSort);
	          _lodash2.default.each(self.personalBests, self.addEventSortKey);
	        }
	      });
	    },
	    cleanTilpaData: function cleanTilpaData(obj) {
	      var keysToRename = {
	        'firstname': 'givenName',
	        'lastname': 'familyName',
	        'eventCode': 'event'
	      };
	
	      function cleanObject(o) {
	        var build, key, destKey, value;
	        build = {};
	        for (key in o) {
	          destKey = keysToRename[key] || key;
	          value = o[key];
	          if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
	            value = cleanObject(value);
	          }
	          build[destKey] = value;
	        }
	        return build;
	      }
	      return cleanObject(obj);
	    },
	    distinctEvents: function distinctEvents() {
	      var evs = {};
	      var result;
	      var i;
	      for (i = 0; i < this.results.length; i++) {
	        result = this.results[i];
	        evs[result.eventKey] = result.event;
	      }
	
	      return (0, _lodash2.default)(evs).toPairs().sortBy(0).fromPairs().values().value();
	    },
	    yearRange: function yearRange() {
	      var i, earliest, latest, result, yyyy;
	      for (i = 0; i < this.results.length; i++) {
	        result = this.results[i];
	        yyyy = result.date.slice(0, 4);
	
	        if (i === 0) {
	          earliest = yyyy;
	          latest = yyyy;
	        } else {
	          if (yyyy < earliest) {
	            earliest = yyyy;
	          }
	          if (yyyy > latest) {
	            latest = yyyy;
	          }
	        }
	      }
	      return [earliest, latest];
	    },
	
	    years: function years() {
	      var yrs = [];
	      var rng = this.yearRange();
	      var earliest = parseInt(rng[0]);
	      var latest = parseInt(rng[1]);
	
	      for (var yyyy = latest; yyyy >= earliest; yyyy--) {
	        yrs.push(yyyy.toString());
	      }
	      return yrs;
	    },
	    windy: function windy(wind) {
	      return parseFloat(wind) > 2.0;
	    },
	    formatWind: function formatWind(wind) {
	      var includePlus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      wind = wind.replace('++', '');
	      wind = wind.replace('+', '');
	
	      if (includePlus && parseFloat(wind) > 0) wind = '+' + wind;
	
	      return wind;
	    }
	  },
	  computed: {
	    resultsByYear: function resultsByYear() {
	      var self = this;
	      var out = {};
	      var result = [];
	      var yr = null;
	      _lodash2.default.each(self.results, function (row) {
	        yr = row.date.substr(0, 4);
	        if (out.hasOwnProperty(yr)) {
	          out[yr].push(row);
	        } else {
	          out[yr] = [row];
	        }
	      });
	      out = (0, _values2.default)(out);
	      out = _lodash2.default.orderBy(out, function (obj) {
	        return obj[0].date;
	      }, 'desc');
	
	      _lodash2.default.each(out, function (obj, index) {
	        result.push(obj);
	      });
	
	      return result;
	    },
	    displayYears: function displayYears() {
	      return this.years();
	    },
	
	    bestsByYearAndEvent: function bestsByYearAndEvent() {
	      var yearlyBests = {};
	      var lifetimeBests = {};
	      var evs, ev, yyyy, result, i, perf;
	      for (i = 0; i < this.results.length; i++) {
	        result = this.results[i];
	        if (result.okForSB) {
	          ev = result.event;
	          perf = result.result;
	          yyyy = result.date.slice(0, 4);
	
	          if ([ev, yyyy] in yearlyBests) {
	            if (perf === (0, _athlib.betterPerformance)(yearlyBests[[ev, yyyy]][0], perf, ev)) {
	              yearlyBests[[ev, yyyy]] = [perf, result.id];
	            }
	          } else {
	            yearlyBests[[ev, yyyy]] = [perf, result.id];
	          }
	
	          if (ev in lifetimeBests) {
	            if (perf === (0, _athlib.betterPerformance)(lifetimeBests[ev][0], perf, ev)) {
	              lifetimeBests[ev] = [perf, result.id];
	            }
	          } else {
	            lifetimeBests[ev] = [perf, result.id];
	          }
	        }
	      }
	
	      var rows = [];
	      var row, yrs;
	
	      yrs = this.years();
	      evs = this.distinctEvents();
	      for (i = 0; i < evs.length; i++) {
	        ev = evs[i];
	        row = [[ev, false]];
	        row.push(lifetimeBests[ev] || ['-', false]);
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(yrs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            yyyy = _step.value;
	
	            row.push(yearlyBests[[ev, yyyy]]);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        rows.push(row);
	      }
	      return rows;
	    }
	
	  },
	  created: function created() {
	    var self = this;
	    self.dummy = 'loading';
	    self.loadTilastopaja();
	    self.dummy = 'loaded';
	  }
	};

/***/ },
/* 217 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    msgid: String,
	    msgstr: String
	  },
	  template: '<span></span>',
	  created: function created() {
	    var self = this;
	    self.$parent.$emit('translation-custom', self.msgid, self.msgstr);
	  }
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(226);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(225);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  data: function data() {
	    return {
	      loaded: false,
	      name: 'Wait for it...'
	    };
	  },
	
	  methods: {
	    loadStuff: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(done) {
	        var self, response, stuff;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                self = this;
	                _context.next = 3;
	                return self.$http.get('https://api.randomuser.me/', {});
	
	              case 3:
	                response = _context.sent;
	                _context.next = 6;
	                return response.json();
	
	              case 6:
	                stuff = _context.sent;
	
	                self.name = stuff['results'][0].login.username;
	                self.loaded = true;
	                return _context.abrupt('return', self.loaded);
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function loadStuff(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return loadStuff;
	    }()
	  },
	  mounted: function mounted() {
	    this.loadStuff();
	  }
	};

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TranslationMixin = __webpack_require__(15);
	
	var _TranslationMixin2 = _interopRequireDefault(_TranslationMixin);
	
	var _countries = __webpack_require__(286);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _lodash = __webpack_require__(9);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_TranslationMixin2.default],
	  props: {
	    value: {
	      type: Object
	    },
	    suggestions: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    allowUnattached: {
	      type: Boolean,
	      default: function _default() {
	        return true;
	      }
	    },
	    countries: {
	      type: Array,
	      default: function _default() {
	        return _countries2.default;
	      }
	    },
	    country: {
	      type: String,
	      default: function _default() {
	        return null;
	      }
	    },
	    url: {
	      type: String,
	      default: function _default() {
	        return '/api/orgs/';
	      }
	    },
	    allowInternational: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    },
	    orgTypes: {
	      type: Array,
	      default: function _default() {
	        return ['CLUB'];
	      }
	    },
	    fieldName: {
	      type: String,
	      default: function _default() {
	        return 'affiliation';
	      }
	    }
	  },
	  data: function data() {
	    return {
	      open: false,
	      output: {},
	      text: '',
	      orgMode: 'affiliated',
	      club: '',
	      currentCountry: '',
	      matches: [],
	      clubCode: '',
	      newClub: false,
	      current: 0,
	      tempOutput: {},
	      orgType: ''
	    };
	  },
	
	  methods: {
	    changeCountry: function changeCountry(ev) {
	      var self = this;
	      var countrySelect = ev.target;
	      self.currentCountry = countrySelect.value;
	    },
	    updateValue: function updateValue(value) {
	      if (this.open === false) {
	        this.open = true;
	        this.current = 0;
	      }
	      this.$emit('input', value);
	    },
	    up: function up() {
	      if (this.current > 0) {
	        this.current--;
	      }
	    },
	    down: function down() {
	      if (this.current < this.matches.length - 1) {
	        this.current++;
	      }
	    },
	    isActive: function isActive(index) {
	      return index === this.current;
	    },
	    suggestionClick: function suggestionClick(index) {
	      var self = this;
	      var text = '';
	      var found = self.matches[index];
	      if (found.code) {
	        self.$emit('input', found.code);
	        self.output.code = found.code;
	        text = found.code + ' - ';
	      } else {
	        text = '';
	        delete self.output.code;
	      }
	      text += found.name;
	      self.output.name = found.name;
	      if (String(self.orgMode) === 'international') text += ' [' + self.currentCountry + ']';
	      if (found.id) {
	        self.output.id = found.id;
	      }
	      self.open = false;
	      self.text = text;
	    },
	    enter: function enter() {
	      this.suggestionClick(this.current);
	    },
	
	    getClubs: function getClubs(v) {
	      var self = this;
	      var lv = v.toLowerCase();
	      if (self.suggestions.length) {
	        self.matches = self.suggestions.filter(function (obj) {
	          var codeMatch = obj[0] ? obj[0].toLowerCase().indexOf(lv) >= 0 : false;
	          var nameMatch = obj[1] ? obj[1].toLowerCase().indexOf(lv) >= 0 : false;
	          return codeMatch || nameMatch;
	        }).map(function (obj) {
	          return { code: obj[0], name: obj[1] };
	        });
	      } else if (v.length > 1) {
	        var url = self.url + '?';
	        if (self.currentCountry) url += 'country=' + encodeURIComponent(self.currentCountry) + '&';
	        self.matches = [];
	        self.orgTypes.forEach(function (ot) {
	          var uri = url + 'org_type=' + encodeURIComponent(ot) + '&query=' + encodeURIComponent(v);
	          self.$http.get(uri).then(function (response) {
	            if (response.body.options) {
	              self.matches = self.matches.concat(response.body.options);
	              _lodash2.default.sortBy(self.matches, ['code', 'name']);
	            }
	          });
	        });
	      }
	    }
	  },
	  computed: {
	    openSuggestion: function openSuggestion() {
	      return this.matches.length !== 0 && this.open === true;
	    }
	  },
	  watch: {
	    text: function text(newValue) {
	      if (!newValue.length) {
	        this.output = {};
	      } else {
	        this.getClubs(newValue);
	      }
	    },
	    orgMode: function orgMode(val) {
	      if (String(val) === 'unattached') {
	        this.tempOutput = this.output;
	        this.output = { code: 'UNATT', name: 'Not a club member' };
	        this.text = '';
	      } else {
	        if (String(val) === 'affiliated') {
	          this.output = this.tempOutput;
	          this.tempOutput = {};
	        }
	      }
	    }
	  },
	  created: function created() {
	    var self = this;
	
	    if (typeof self.value === 'string') {
	      self.output = {};
	      self.orgMode = 'affiliated';
	      self.text = self.value;
	    } else {
	      self.orgMode = 'unattached';
	      if (!self.value) {
	        self.output = { code: 'UNATT', name: 'Not a club member' };
	      } else {
	        self.output = self.value;
	      }
	
	      if (String(self.output.code) !== 'UNATT') {
	        if (self.value.country && self.allowInternational) {
	          self.orgMode = 'international';
	        } else {
	          self.orgMode = 'affiliated';
	        }
	      }
	
	      self.text = '';
	      if (self.output.code) {
	        self.text = self.output.code;
	      }
	      if (self.output.name) {
	        if (self.text.length) self.text += ' - ';
	        self.text += self.output.name;
	      }
	      if (self.output.country) {
	        self.text += ' [' + self.output.country + ']';
	      }
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    var orgTypes = self.orgTypes.map(function (ot) {
	      return ot[0].toUpperCase() + ot.slice(1).toLowerCase();
	    });
	    self.orgType = orgTypes.join('/');
	  }
	};

/***/ },
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 273 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 274 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 275 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 276 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 277 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 278 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 279 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 280 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 281 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 282 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 283 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 284 */,
/* 285 */,
/* 286 */
/***/ function(module, exports) {

	module.exports = [
		{
			"name": "(to be confirmed)",
			"code": "TBC"
		},
		{
			"name": "Afghanistan",
			"code": "AFG"
		},
		{
			"name": "Åland Islands",
			"code": "ALA"
		},
		{
			"name": "Albania",
			"code": "ALB"
		},
		{
			"name": "Algeria",
			"code": "DZA"
		},
		{
			"name": "American Samoa",
			"code": "ASM"
		},
		{
			"name": "Andorra",
			"code": "AND"
		},
		{
			"name": "Angola",
			"code": "AGO"
		},
		{
			"name": "Anguilla",
			"code": "AIA"
		},
		{
			"name": "Antarctica",
			"code": "ATA"
		},
		{
			"name": "Antigua and Barbuda",
			"code": "ATG"
		},
		{
			"name": "Argentina",
			"code": "ARG"
		},
		{
			"name": "Armenia",
			"code": "ARM"
		},
		{
			"name": "Aruba",
			"code": "ABW"
		},
		{
			"name": "Australia",
			"code": "AUS"
		},
		{
			"name": "Austria",
			"code": "AUT"
		},
		{
			"name": "Azerbaijan",
			"code": "AZE"
		},
		{
			"name": "Bahamas",
			"code": "BHS"
		},
		{
			"name": "Bahrain",
			"code": "BHR"
		},
		{
			"name": "Bangladesh",
			"code": "BGD"
		},
		{
			"name": "Barbados",
			"code": "BRB"
		},
		{
			"name": "Belarus",
			"code": "BLR"
		},
		{
			"name": "Belgium",
			"code": "BEL"
		},
		{
			"name": "Belize",
			"code": "BLZ"
		},
		{
			"name": "Benin",
			"code": "BEN"
		},
		{
			"name": "Bermuda",
			"code": "BMU"
		},
		{
			"name": "Bhutan",
			"code": "BTN"
		},
		{
			"name": "Bolivia, Plurinational State of",
			"code": "BOL"
		},
		{
			"name": "Bonaire, Sint Eustatius and Saba",
			"code": "BES"
		},
		{
			"name": "Bosnia Herzegovina",
			"code": "BIH"
		},
		{
			"name": "Botswana",
			"code": "BWA"
		},
		{
			"name": "Bouvet Island",
			"code": "BVT"
		},
		{
			"name": "Brazil",
			"code": "BRA"
		},
		{
			"name": "British Indian Ocean Territory",
			"code": "IOT"
		},
		{
			"name": "Brunei Darussalam",
			"code": "BRN"
		},
		{
			"name": "Bulgaria",
			"code": "BGR"
		},
		{
			"name": "Burkina Faso",
			"code": "BFA"
		},
		{
			"name": "Burundi",
			"code": "BDI"
		},
		{
			"name": "Cambodia",
			"code": "KHM"
		},
		{
			"name": "Cameroon",
			"code": "CMR"
		},
		{
			"name": "Canada",
			"code": "CAN"
		},
		{
			"name": "Cape Verde",
			"code": "CPV"
		},
		{
			"name": "Cayman Islands",
			"code": "CYM"
		},
		{
			"name": "Central African Republic",
			"code": "CAF"
		},
		{
			"name": "Chad",
			"code": "TCD"
		},
		{
			"name": "Chile",
			"code": "CHL"
		},
		{
			"name": "China",
			"code": "CHN"
		},
		{
			"name": "Christmas Island",
			"code": "CXR"
		},
		{
			"name": "Cocos (Keeling) Islands",
			"code": "CCK"
		},
		{
			"name": "Colombia",
			"code": "COL"
		},
		{
			"name": "Comoros",
			"code": "COM"
		},
		{
			"name": "Congo",
			"code": "COG"
		},
		{
			"name": "Congo, Democratic Republic of the",
			"code": "COD"
		},
		{
			"name": "Cook Islands",
			"code": "COK"
		},
		{
			"name": "Costa Rica",
			"code": "CRI"
		},
		{
			"name": "Côte d'Ivoire",
			"code": "CIV"
		},
		{
			"name": "Croatia",
			"code": "HRV"
		},
		{
			"name": "Cuba",
			"code": "CUB"
		},
		{
			"name": "Curaçao",
			"code": "CUW"
		},
		{
			"name": "Cyprus",
			"code": "CYP"
		},
		{
			"name": "Czech Republic",
			"code": "CZE"
		},
		{
			"name": "Denmark",
			"code": "DNK"
		},
		{
			"name": "Djibouti",
			"code": "DJI"
		},
		{
			"name": "Dominica",
			"code": "DMA"
		},
		{
			"name": "Dominican Republic",
			"code": "DOM"
		},
		{
			"name": "Ecuador",
			"code": "ECU"
		},
		{
			"name": "Egypt",
			"code": "EGY"
		},
		{
			"name": "El Salvador",
			"code": "SLV"
		},
		{
			"name": "Equatorial Guinea",
			"code": "GNQ"
		},
		{
			"name": "Eritrea",
			"code": "ERI"
		},
		{
			"name": "Estonia",
			"code": "EST"
		},
		{
			"name": "Ethiopia",
			"code": "ETH"
		},
		{
			"name": "Falkland Islands (Malvinas)",
			"code": "FLK"
		},
		{
			"name": "Faroe Islands",
			"code": "FRO"
		},
		{
			"name": "Fiji",
			"code": "FJI"
		},
		{
			"name": "Finland",
			"code": "FIN"
		},
		{
			"name": "France",
			"code": "FRA"
		},
		{
			"name": "French Guiana",
			"code": "GUF"
		},
		{
			"name": "French Polynesia",
			"code": "PYF"
		},
		{
			"name": "French Southern Territories",
			"code": "ATF"
		},
		{
			"name": "Gabon",
			"code": "GAB"
		},
		{
			"name": "Gambia",
			"code": "GMB"
		},
		{
			"name": "Georgia",
			"code": "GEO"
		},
		{
			"name": "Germany",
			"code": "DEU"
		},
		{
			"name": "Ghana",
			"code": "GHA"
		},
		{
			"name": "Gibraltar",
			"code": "GIB"
		},
		{
			"name": "Greece",
			"code": "GRC"
		},
		{
			"name": "Greenland",
			"code": "GRL"
		},
		{
			"name": "Grenada",
			"code": "GRD"
		},
		{
			"name": "Guadeloupe",
			"code": "GLP"
		},
		{
			"name": "Guam",
			"code": "GUM"
		},
		{
			"name": "Guatemala",
			"code": "GTM"
		},
		{
			"name": "Guernsey",
			"code": "GGY"
		},
		{
			"name": "Guinea",
			"code": "GIN"
		},
		{
			"name": "Guinea-Bissau",
			"code": "GNB"
		},
		{
			"name": "Guyana",
			"code": "GUY"
		},
		{
			"name": "Haiti",
			"code": "HTI"
		},
		{
			"name": "Heard Island and McDonald Islands",
			"code": "HMD"
		},
		{
			"name": "Holy See (Vatican City State)",
			"code": "VAT"
		},
		{
			"name": "Honduras",
			"code": "HND"
		},
		{
			"name": "Hong Kong",
			"code": "HKG"
		},
		{
			"name": "Hungary",
			"code": "HUN"
		},
		{
			"name": "Iceland",
			"code": "ISL"
		},
		{
			"name": "India",
			"code": "IND"
		},
		{
			"name": "Indonesia",
			"code": "IDN"
		},
		{
			"name": "Iran, Islamic Republic of",
			"code": "IRN"
		},
		{
			"name": "Iraq",
			"code": "IRQ"
		},
		{
			"name": "Ireland",
			"code": "IRL"
		},
		{
			"name": "Isle of Man",
			"code": "IMN"
		},
		{
			"name": "Israel",
			"code": "ISR"
		},
		{
			"name": "Italy",
			"code": "ITA"
		},
		{
			"name": "Jamaica",
			"code": "JAM"
		},
		{
			"name": "Japan",
			"code": "JPN"
		},
		{
			"name": "Jersey",
			"code": "JEY"
		},
		{
			"name": "Jordan",
			"code": "JOR"
		},
		{
			"name": "Kazakhstan",
			"code": "KAZ"
		},
		{
			"name": "Kenya",
			"code": "KEN"
		},
		{
			"name": "Kiribati",
			"code": "KIR"
		},
		{
			"name": "Korea, Democratic People's Republic of",
			"code": "PRK"
		},
		{
			"name": "Korea, Republic of",
			"code": "KOR"
		},
		{
			"name": "Kosovo",
			"code": "KOS"
		},
		{
			"name": "Kuwait",
			"code": "KWT"
		},
		{
			"name": "Kyrgyzstan",
			"code": "KGZ"
		},
		{
			"name": "Lao People's Democratic Republic",
			"code": "LAO"
		},
		{
			"name": "Latvia",
			"code": "LVA"
		},
		{
			"name": "Lebanon",
			"code": "LBN"
		},
		{
			"name": "Lesotho",
			"code": "LSO"
		},
		{
			"name": "Liberia",
			"code": "LBR"
		},
		{
			"name": "Libya",
			"code": "LBY"
		},
		{
			"name": "Liechtenstein",
			"code": "LIE"
		},
		{
			"name": "Lithuania",
			"code": "LTU"
		},
		{
			"name": "Luxembourg",
			"code": "LUX"
		},
		{
			"name": "Macao",
			"code": "MAC"
		},
		{
			"name": "Madagascar",
			"code": "MDG"
		},
		{
			"name": "Malawi",
			"code": "MWI"
		},
		{
			"name": "Malaysia",
			"code": "MYS"
		},
		{
			"name": "Maldives",
			"code": "MDV"
		},
		{
			"name": "Mali",
			"code": "MLI"
		},
		{
			"name": "Malta",
			"code": "MLT"
		},
		{
			"name": "Marshall Islands",
			"code": "MHL"
		},
		{
			"name": "Martinique",
			"code": "MTQ"
		},
		{
			"name": "Mauritania",
			"code": "MRT"
		},
		{
			"name": "Mauritius",
			"code": "MUS"
		},
		{
			"name": "Mayotte",
			"code": "MYT"
		},
		{
			"name": "Mexico",
			"code": "MEX"
		},
		{
			"name": "Micronesia, Federated States of",
			"code": "FSM"
		},
		{
			"name": "Moldova, Republic of",
			"code": "MDA"
		},
		{
			"name": "Monaco",
			"code": "MCO"
		},
		{
			"name": "Mongolia",
			"code": "MNG"
		},
		{
			"name": "Montenegro",
			"code": "MNE"
		},
		{
			"name": "Montserrat",
			"code": "MSR"
		},
		{
			"name": "Morocco",
			"code": "MAR"
		},
		{
			"name": "Mozambique",
			"code": "MOZ"
		},
		{
			"name": "Myanmar",
			"code": "MMR"
		},
		{
			"name": "Namibia",
			"code": "NAM"
		},
		{
			"name": "Nauru",
			"code": "NRU"
		},
		{
			"name": "Nepal",
			"code": "NPL"
		},
		{
			"name": "Netherlands",
			"code": "NLD"
		},
		{
			"name": "New Caledonia",
			"code": "NCL"
		},
		{
			"name": "New Zealand",
			"code": "NZL"
		},
		{
			"name": "Nicaragua",
			"code": "NIC"
		},
		{
			"name": "Niger",
			"code": "NER"
		},
		{
			"name": "Nigeria",
			"code": "NGA"
		},
		{
			"name": "Niue",
			"code": "NIU"
		},
		{
			"name": "Norfolk Island",
			"code": "NFK"
		},
		{
			"name": "North Macedonia",
			"code": "MKD"
		},
		{
			"name": "Northern Mariana Islands",
			"code": "MNP"
		},
		{
			"name": "Norway",
			"code": "NOR"
		},
		{
			"name": "Oman",
			"code": "OMN"
		},
		{
			"name": "Pakistan",
			"code": "PAK"
		},
		{
			"name": "Palau",
			"code": "PLW"
		},
		{
			"name": "Palestine, State of",
			"code": "PSE"
		},
		{
			"name": "Panama",
			"code": "PAN"
		},
		{
			"name": "Papua New Guinea",
			"code": "PNG"
		},
		{
			"name": "Paraguay",
			"code": "PRY"
		},
		{
			"name": "Peru",
			"code": "PER"
		},
		{
			"name": "Philippines",
			"code": "PHL"
		},
		{
			"name": "Pitcairn",
			"code": "PCN"
		},
		{
			"name": "Poland",
			"code": "POL"
		},
		{
			"name": "Portugal",
			"code": "PRT"
		},
		{
			"name": "Puerto Rico",
			"code": "PRI"
		},
		{
			"name": "Qatar",
			"code": "QAT"
		},
		{
			"name": "Réunion",
			"code": "REU"
		},
		{
			"name": "Romania",
			"code": "ROU"
		},
		{
			"name": "Russia",
			"code": "RUS"
		},
		{
			"name": "Rwanda",
			"code": "RWA"
		},
		{
			"name": "Saint Barthélemy",
			"code": "BLM"
		},
		{
			"name": "Saint Helena, Ascension and Tristan da Cunha",
			"code": "SHN"
		},
		{
			"name": "Saint Kitts and Nevis",
			"code": "KNA"
		},
		{
			"name": "Saint Lucia",
			"code": "LCA"
		},
		{
			"name": "Saint Martin (French part)",
			"code": "MAF"
		},
		{
			"name": "Saint Pierre and Miquelon",
			"code": "SPM"
		},
		{
			"name": "Saint Vincent",
			"code": "VCT"
		},
		{
			"name": "Samoa",
			"code": "WSM"
		},
		{
			"name": "San Marino",
			"code": "SMR"
		},
		{
			"name": "Sao Tome and Principe",
			"code": "STP"
		},
		{
			"name": "Saudi Arabia",
			"code": "SAU"
		},
		{
			"name": "Senegal",
			"code": "SEN"
		},
		{
			"name": "Serbia",
			"code": "SRB"
		},
		{
			"name": "Seychelles",
			"code": "SYC"
		},
		{
			"name": "Sierra Leone",
			"code": "SLE"
		},
		{
			"name": "Singapore",
			"code": "SGP"
		},
		{
			"name": "Sint Maarten (Dutch part)",
			"code": "SXM"
		},
		{
			"name": "Slovak Republic",
			"code": "SVK"
		},
		{
			"name": "Slovenia",
			"code": "SVN"
		},
		{
			"name": "Solomon Islands",
			"code": "SLB"
		},
		{
			"name": "Somalia",
			"code": "SOM"
		},
		{
			"name": "South Africa",
			"code": "ZAF"
		},
		{
			"name": "South Georgia and the South Sandwich Islands",
			"code": "SGS"
		},
		{
			"name": "South Sudan",
			"code": "SSD"
		},
		{
			"name": "Spain",
			"code": "ESP"
		},
		{
			"name": "Sri Lanka",
			"code": "LKA"
		},
		{
			"name": "Sudan",
			"code": "SDN"
		},
		{
			"name": "Suriname",
			"code": "SUR"
		},
		{
			"name": "Svalbard and Jan Mayen",
			"code": "SJM"
		},
		{
			"name": "Swaziland",
			"code": "SWZ"
		},
		{
			"name": "Sweden",
			"code": "SWE"
		},
		{
			"name": "Switzerland",
			"code": "CHE"
		},
		{
			"name": "Syrian Arab Republic",
			"code": "SYR"
		},
		{
			"name": "Taiwan, Province of China",
			"code": "TWN"
		},
		{
			"name": "Tajikistan",
			"code": "TJK"
		},
		{
			"name": "Tanzania, United Republic of",
			"code": "TZA"
		},
		{
			"name": "Thailand",
			"code": "THA"
		},
		{
			"name": "Timor-Leste",
			"code": "TLS"
		},
		{
			"name": "Togo",
			"code": "TGO"
		},
		{
			"name": "Tokelau",
			"code": "TKL"
		},
		{
			"name": "Tonga",
			"code": "TON"
		},
		{
			"name": "Trinidad and Tobago",
			"code": "TTO"
		},
		{
			"name": "Tunisia",
			"code": "TUN"
		},
		{
			"name": "Turkey",
			"code": "TUR"
		},
		{
			"name": "Turkmenistan",
			"code": "TKM"
		},
		{
			"name": "Turks and Caicos Islands",
			"code": "TCA"
		},
		{
			"name": "Tuvalu",
			"code": "TUV"
		},
		{
			"name": "Uganda",
			"code": "UGA"
		},
		{
			"name": "Ukraine",
			"code": "UKR"
		},
		{
			"name": "United Arab Emirates",
			"code": "ARE"
		},
		{
			"name": "United Kingdom",
			"code": "GBR"
		},
		{
			"name": "United States",
			"code": "USA"
		},
		{
			"name": "United States Minor Outlying Islands",
			"code": "UMI"
		},
		{
			"name": "Uruguay",
			"code": "URY"
		},
		{
			"name": "Uzbekistan",
			"code": "UZB"
		},
		{
			"name": "Vanuatu",
			"code": "VUT"
		},
		{
			"name": "Venezuela, Bolivarian Republic of",
			"code": "VEN"
		},
		{
			"name": "Vietnam",
			"code": "VNM"
		},
		{
			"name": "Virgin Islands, British",
			"code": "VGB"
		},
		{
			"name": "Virgin Islands, U.S.",
			"code": "VIR"
		},
		{
			"name": "Wallis and Futuna",
			"code": "WLF"
		},
		{
			"name": "Western Sahara",
			"code": "ESH"
		},
		{
			"name": "Yemen",
			"code": "YEM"
		},
		{
			"name": "Zambia",
			"code": "ZMB"
		},
		{
			"name": "Zimbabwe",
			"code": "ZWE"
		}
	];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 59,
		"./af.js": 59,
		"./ar": 66,
		"./ar-dz": 60,
		"./ar-dz.js": 60,
		"./ar-kw": 61,
		"./ar-kw.js": 61,
		"./ar-ly": 62,
		"./ar-ly.js": 62,
		"./ar-ma": 63,
		"./ar-ma.js": 63,
		"./ar-sa": 64,
		"./ar-sa.js": 64,
		"./ar-tn": 65,
		"./ar-tn.js": 65,
		"./ar.js": 66,
		"./az": 67,
		"./az.js": 67,
		"./be": 68,
		"./be.js": 68,
		"./bg": 69,
		"./bg.js": 69,
		"./bm": 70,
		"./bm.js": 70,
		"./bn": 72,
		"./bn-bd": 71,
		"./bn-bd.js": 71,
		"./bn.js": 72,
		"./bo": 73,
		"./bo.js": 73,
		"./br": 74,
		"./br.js": 74,
		"./bs": 75,
		"./bs.js": 75,
		"./ca": 76,
		"./ca.js": 76,
		"./cs": 77,
		"./cs.js": 77,
		"./cv": 78,
		"./cv.js": 78,
		"./cy": 79,
		"./cy.js": 79,
		"./da": 80,
		"./da.js": 80,
		"./de": 83,
		"./de-at": 81,
		"./de-at.js": 81,
		"./de-ch": 82,
		"./de-ch.js": 82,
		"./de.js": 83,
		"./dv": 84,
		"./dv.js": 84,
		"./el": 85,
		"./el.js": 85,
		"./en-au": 86,
		"./en-au.js": 86,
		"./en-ca": 87,
		"./en-ca.js": 87,
		"./en-gb": 88,
		"./en-gb.js": 88,
		"./en-ie": 89,
		"./en-ie.js": 89,
		"./en-il": 90,
		"./en-il.js": 90,
		"./en-in": 91,
		"./en-in.js": 91,
		"./en-nz": 92,
		"./en-nz.js": 92,
		"./en-sg": 93,
		"./en-sg.js": 93,
		"./eo": 94,
		"./eo.js": 94,
		"./es": 98,
		"./es-do": 95,
		"./es-do.js": 95,
		"./es-mx": 96,
		"./es-mx.js": 96,
		"./es-us": 97,
		"./es-us.js": 97,
		"./es.js": 98,
		"./et": 99,
		"./et.js": 99,
		"./eu": 100,
		"./eu.js": 100,
		"./fa": 101,
		"./fa.js": 101,
		"./fi": 102,
		"./fi.js": 102,
		"./fil": 103,
		"./fil.js": 103,
		"./fo": 104,
		"./fo.js": 104,
		"./fr": 107,
		"./fr-ca": 105,
		"./fr-ca.js": 105,
		"./fr-ch": 106,
		"./fr-ch.js": 106,
		"./fr.js": 107,
		"./fy": 108,
		"./fy.js": 108,
		"./ga": 109,
		"./ga.js": 109,
		"./gd": 110,
		"./gd.js": 110,
		"./gl": 111,
		"./gl.js": 111,
		"./gom-deva": 112,
		"./gom-deva.js": 112,
		"./gom-latn": 113,
		"./gom-latn.js": 113,
		"./gu": 114,
		"./gu.js": 114,
		"./he": 115,
		"./he.js": 115,
		"./hi": 116,
		"./hi.js": 116,
		"./hr": 117,
		"./hr.js": 117,
		"./hu": 118,
		"./hu.js": 118,
		"./hy-am": 119,
		"./hy-am.js": 119,
		"./id": 120,
		"./id.js": 120,
		"./is": 121,
		"./is.js": 121,
		"./it": 123,
		"./it-ch": 122,
		"./it-ch.js": 122,
		"./it.js": 123,
		"./ja": 124,
		"./ja.js": 124,
		"./jv": 125,
		"./jv.js": 125,
		"./ka": 126,
		"./ka.js": 126,
		"./kk": 127,
		"./kk.js": 127,
		"./km": 128,
		"./km.js": 128,
		"./kn": 129,
		"./kn.js": 129,
		"./ko": 130,
		"./ko.js": 130,
		"./ku": 131,
		"./ku.js": 131,
		"./ky": 132,
		"./ky.js": 132,
		"./lb": 133,
		"./lb.js": 133,
		"./lo": 134,
		"./lo.js": 134,
		"./lt": 135,
		"./lt.js": 135,
		"./lv": 136,
		"./lv.js": 136,
		"./me": 137,
		"./me.js": 137,
		"./mi": 138,
		"./mi.js": 138,
		"./mk": 139,
		"./mk.js": 139,
		"./ml": 140,
		"./ml.js": 140,
		"./mn": 141,
		"./mn.js": 141,
		"./mr": 142,
		"./mr.js": 142,
		"./ms": 144,
		"./ms-my": 143,
		"./ms-my.js": 143,
		"./ms.js": 144,
		"./mt": 145,
		"./mt.js": 145,
		"./my": 146,
		"./my.js": 146,
		"./nb": 147,
		"./nb.js": 147,
		"./ne": 148,
		"./ne.js": 148,
		"./nl": 150,
		"./nl-be": 149,
		"./nl-be.js": 149,
		"./nl.js": 150,
		"./nn": 151,
		"./nn.js": 151,
		"./oc-lnc": 152,
		"./oc-lnc.js": 152,
		"./pa-in": 153,
		"./pa-in.js": 153,
		"./pl": 154,
		"./pl.js": 154,
		"./pt": 156,
		"./pt-br": 155,
		"./pt-br.js": 155,
		"./pt.js": 156,
		"./ro": 157,
		"./ro.js": 157,
		"./ru": 158,
		"./ru.js": 158,
		"./sd": 159,
		"./sd.js": 159,
		"./se": 160,
		"./se.js": 160,
		"./si": 161,
		"./si.js": 161,
		"./sk": 162,
		"./sk.js": 162,
		"./sl": 163,
		"./sl.js": 163,
		"./sq": 164,
		"./sq.js": 164,
		"./sr": 166,
		"./sr-cyrl": 165,
		"./sr-cyrl.js": 165,
		"./sr.js": 166,
		"./ss": 167,
		"./ss.js": 167,
		"./sv": 168,
		"./sv.js": 168,
		"./sw": 169,
		"./sw.js": 169,
		"./ta": 170,
		"./ta.js": 170,
		"./te": 171,
		"./te.js": 171,
		"./tet": 172,
		"./tet.js": 172,
		"./tg": 173,
		"./tg.js": 173,
		"./th": 174,
		"./th.js": 174,
		"./tk": 175,
		"./tk.js": 175,
		"./tl-ph": 176,
		"./tl-ph.js": 176,
		"./tlh": 177,
		"./tlh.js": 177,
		"./tr": 178,
		"./tr.js": 178,
		"./tzl": 179,
		"./tzl.js": 179,
		"./tzm": 181,
		"./tzm-latn": 180,
		"./tzm-latn.js": 180,
		"./tzm.js": 181,
		"./ug-cn": 182,
		"./ug-cn.js": 182,
		"./uk": 183,
		"./uk.js": 183,
		"./ur": 184,
		"./ur.js": 184,
		"./uz": 186,
		"./uz-latn": 185,
		"./uz-latn.js": 185,
		"./uz.js": 186,
		"./vi": 187,
		"./vi.js": 187,
		"./x-pseudo": 188,
		"./x-pseudo.js": 188,
		"./yo": 189,
		"./yo.js": 189,
		"./zh-cn": 190,
		"./zh-cn.js": 190,
		"./zh-hk": 191,
		"./zh-hk.js": 191,
		"./zh-mo": 192,
		"./zh-mo.js": 192,
		"./zh-tw": 193,
		"./zh-tw.js": 193
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 287;


/***/ },
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(274)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(204),
	  /* template */
	  __webpack_require__(307),
	  /* scopeId */
	  "data-v-1cc8b018",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(276)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(219),
	  /* template */
	  __webpack_require__(309),
	  /* scopeId */
	  "data-v-423f0983",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(278)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(205),
	  /* template */
	  __webpack_require__(313),
	  /* scopeId */
	  "data-v-7ba9dc88",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(281)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(206),
	  /* template */
	  __webpack_require__(318),
	  /* scopeId */
	  "data-v-d7dce524",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(275)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(207),
	  /* template */
	  __webpack_require__(308),
	  /* scopeId */
	  "data-v-29cded9d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(272)
	__webpack_require__(273)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(208),
	  /* template */
	  __webpack_require__(305),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(277)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(209),
	  /* template */
	  __webpack_require__(311),
	  /* scopeId */
	  "data-v-54152a56",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(210),
	  /* template */
	  __webpack_require__(312),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(218),
	  /* template */
	  __webpack_require__(306),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(280)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(211),
	  /* template */
	  __webpack_require__(317),
	  /* scopeId */
	  "data-v-d38ca648",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(212),
	  /* template */
	  __webpack_require__(315),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(283)
	__webpack_require__(282)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(216),
	  /* template */
	  __webpack_require__(319),
	  /* scopeId */
	  "data-v-eb5da08e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(279)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(203),
	  /* template */
	  __webpack_require__(314),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 305 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('handsontable', {
	    attrs: {
	      "data": _vm.data,
	      "settings": _vm.settings
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 306 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('table', {
	    attrs: {
	      "border": ""
	    }
	  }, [_c('h3', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', [_vm._v("loaded:  " + _vm._s(_vm.loaded))])])])
	},staticRenderFns: []}

/***/ },
/* 307 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "closing-date"
	  }, [_c('h2', [_vm._v("Closing date widget")]), _vm._v(" "), _c('p', [_vm._v("Closing date: "), _c('span', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.msg))])])])
	},staticRenderFns: []}

/***/ },
/* 308 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('fieldset', {
	    class: {
	      'date-picker-wrap': true, 'bg-danger': !_vm.assertValidDate()
	    }
	  }, [_c('div', {
	    staticClass: "form-grp"
	  }, [(_vm.showLabels) ? _c('label', {
	    attrs: {
	      "for": 'id-' + _vm.name + '-day'
	    }
	  }, [_vm._v(_vm._s(_vm.trans('day')))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.date.day),
	      expression: "date.day"
	    }],
	    staticClass: "form-control day",
	    attrs: {
	      "pattern": "^((0?[1-9])|([12][0-9])|(3[01]))$",
	      "id": 'id-' + _vm.name + '-day',
	      "placeholder": _vm.trans('day'),
	      "min": "1",
	      "max": "31"
	    },
	    domProps: {
	      "value": _vm._s(_vm.date.day)
	    },
	    on: {
	      "focus": _vm.highlight,
	      "keypress": _vm.digitsOnly,
	      "keyup": _vm.doneDigits,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.date.day = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-grp"
	  }, [(_vm.showLabels) ? _c('label', {
	    attrs: {
	      "for": 'id-' + _vm.name + '-month'
	    }
	  }, [_vm._v(_vm._s(_vm.trans('month')))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.date.month),
	      expression: "date.month"
	    }],
	    staticClass: "form-control month",
	    attrs: {
	      "pattern": "^((0?[1-9])|(1[012]))$",
	      "id": 'id-' + _vm.name + '-month',
	      "placeholder": _vm.trans('month'),
	      "max": "12",
	      "min": "1"
	    },
	    domProps: {
	      "value": _vm._s(_vm.date.month)
	    },
	    on: {
	      "focus": _vm.highlight,
	      "keypress": _vm.digitsOnly,
	      "keyup": _vm.doneDigits,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.date.month = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-grp"
	  }, [(_vm.showLabels) ? _c('label', {
	    attrs: {
	      "for": 'id-' + _vm.name + '-year'
	    }
	  }, [_vm._v(_vm._s(_vm.trans('year')))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.date.year),
	      expression: "date.year"
	    }],
	    staticClass: "form-control year",
	    attrs: {
	      "pattern": "^\\d\\d\\d\\d$",
	      "id": 'id-' + _vm.name + '-year',
	      "placeholder": _vm.trans('year'),
	      "min": _vm.minDate.getFullYear(),
	      "max": _vm.maxDate ? _vm.maxDate.getFullYear() : ''
	    },
	    domProps: {
	      "value": _vm._s(_vm.date.year)
	    },
	    on: {
	      "focus": _vm.highlight,
	      "keypress": _vm.digitsOnly,
	      "keyup": _vm.doneDigits,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.date.year = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": _vm.name
	    },
	    domProps: {
	      "value": _vm.isoString()
	    }
	  }), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 309 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'club-picker-wrap': true, tall: _vm.allowUnattached || _vm.allowInternational
	    }
	  }, [_c('input', {
	    attrs: {
	      "name": _vm.fieldName,
	      "required": _vm.orgMode != 'unattached',
	      "type": "hidden"
	    },
	    domProps: {
	      "value": Object.keys(_vm.output).length > 0 && JSON.stringify(_vm.output) || JSON.stringify(_vm.text)
	    }
	  }), _vm._v(" "), (_vm.allowUnattached || _vm.allowInternational) ? _c('fieldset', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "form-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.orgMode),
	      expression: "orgMode"
	    }],
	    attrs: {
	      "name": "org_mode",
	      "type": "radio",
	      "value": "affiliated"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.orgMode, "affiliated")
	    },
	    on: {
	      "click": function($event) {
	        _vm.orgMode = "affiliated"
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.orgType))]), _vm._v(" "), (_vm.allowUnattached) ? _c('label', {
	    staticClass: "form-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.orgMode),
	      expression: "orgMode"
	    }],
	    attrs: {
	      "name": "org_mode",
	      "type": "radio",
	      "value": "unattached"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.orgMode, "unattached")
	    },
	    on: {
	      "click": function($event) {
	        _vm.orgMode = "unattached"
	      }
	    }
	  }), _vm._v(" Unattached")]) : _vm._e(), _vm._v(" "), (_vm.allowInternational) ? _c('label', {
	    staticClass: "form-label"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.orgMode),
	      expression: "orgMode"
	    }],
	    attrs: {
	      "name": "org_mode",
	      "type": "radio",
	      "value": "international"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.orgMode, "international")
	    },
	    on: {
	      "click": function($event) {
	        _vm.orgMode = "international"
	      }
	    }
	  }), _vm._v(" Foreign Club")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.orgMode == 'international' && _vm.allowInternational) ? _c('fieldset', {
	    staticClass: "form-group col-sm-2"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.currentCountry),
	      expression: "currentCountry",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.currentCountry = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.countries), function(country) {
	    return _c('option', {
	      domProps: {
	        "value": country.code
	      }
	    }, [_vm._v(_vm._s(country.name))])
	  }))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-8"
	  }, [((!_vm.allowUnattached) || (_vm.orgMode !== 'unattached')) ? _c('div', {
	    class: {
	      'open': _vm.openSuggestion
	    },
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.text),
	      expression: "text"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": _vm.orgMode == 'affiliated',
	      "autocomplete": "off"
	    },
	    domProps: {
	      "value": _vm._s(_vm.text)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.text = $event.target.value
	      }, function($event) {
	        _vm.updateValue($event.target.value)
	      }],
	      "keydown": [function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        _vm.enter($event)
	      }, function($event) {
	        if (_vm._k($event.keyCode, "down", 40)) { return; }
	        _vm.down($event)
	      }, function($event) {
	        if (_vm._k($event.keyCode, "up", 38)) { return; }
	        _vm.up($event)
	      }, function($event) {
	        if (_vm._k($event.keyCode, "esc", 27)) { return; }
	        _vm.open = false
	      }]
	    }
	  }), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, _vm._l((_vm.matches), function(suggestion, index) {
	    return _c('li', {
	      class: {
	        'active': _vm.isActive(index)
	      },
	      on: {
	        "click": function($event) {
	          _vm.suggestionClick(index)
	        }
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [_vm._v(_vm._s(suggestion.code) + " "), _c('small', [_vm._v(_vm._s(suggestion.name))])])])
	  }))]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ },
/* 310 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.options.length > 1) ? _c('div', {
	    staticClass: "btn-group"
	  }, [_c('div', {
	    staticClass: "btn-group"
	  }, [_c('button', {
	    staticClass: "btn dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "id": 'dropdownfilter' + _vm.$parent._uid + (_vm.keyName || _vm.keyFunc),
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "true"
	    }
	  }, [_vm._t("default"), _vm._v(" "), _c('small', {
	    class: {
	      'fas fa-filter glyphicon glyphicon-filter': true, 'text-success': _vm.selected.length
	    }
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu dropdown-filter",
	    attrs: {
	      "aria-labelledby": 'dropdownfilter' + _vm.$parent._uid + (_vm.keyName || _vm.keyFunc)
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "overflow": "auto",
	      "max-height": "300px"
	    }
	  }, _vm._l((_vm.options), function(uni) {
	    return _c('button', {
	      class: {
	        'btn btn-sm btn-block': true, 'btn-success': _vm.selected.indexOf(uni) >= 0
	      },
	      staticStyle: {
	        "text-align": "left"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.toggle(uni, $event)
	        }
	      }
	    }, [(_vm.selected.indexOf(uni) >= 0) ? _c('span', {
	      staticClass: "fas fa-check glyphicon glyphicon-ok"
	    }) : _c('span', [_vm._v("   ")]), _vm._v(" "), (_vm.keyFunc) ? _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(uni)
	      }
	    }) : _c('span', [_vm._v("${ uni }")])])
	  }))])]), _vm._v(" "), (_vm.selected.length) ? _c('a', {
	    staticClass: "pl-3",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.reset
	    }
	  }, [_c('span', {
	    staticClass: "fas fa-times glyphicon glyphicon-remove text-danger"
	  })]) : _vm._e()]) : _c('div', [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ },
/* 311 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "btn-group",
	    class: _vm.classes
	  }, [_c('button', {
	    class: _vm.btn_classes ? 'btn dropdown-toggle ' + _vm.btn_classes : 'btn dropdown-toggle',
	    attrs: {
	      "type": "button",
	      "id": 'dropdownfilter' + _vm.keyName,
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "true"
	    }
	  }, [_vm._t("default"), _vm._v(" "), _c('span', {
	    staticClass: "caret"
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu dropdown-filter",
	    attrs: {
	      "aria-labelledby": 'dropdownfilter' + _vm.keyName
	    }
	  }, [_c('div', _vm._l((_vm.univers), function(itm) {
	    return _c('button', {
	      class: {
	        'btn btn-light btn-block border-0 py-0 my-1': true, 'btn-success': _vm.selected.indexOf(itm) >= 0
	      },
	      staticStyle: {
	        "text-align": "left"
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.toggle(itm, $event)
	        }
	      }
	    }, [(_vm.selected.indexOf(itm) >= 0) ? _c('span', {
	      staticClass: "glyphicon glyphicon-ok"
	    }) : _c('span'), _vm._v(" " + _vm._s(itm))])
	  }))]), _vm._v(" "), (_vm.selected.length) ? _c('button', {
	    staticClass: "funnel-reset btn btn-sm",
	    on: {
	      "click": _vm.reset
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-filter fa fas fa-filter"
	  }), _c('span', {
	    staticClass: "glyphicon glyphicon-remove fa fas fa-times text-danger"
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 312 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ },
/* 313 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-one"
	  }, [_c('p', [_vm._v("Component One (should be green)")])])
	}]}

/***/ },
/* 314 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "handsontable"
	  })
	},staticRenderFns: []}

/***/ },
/* 315 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-responsive-md"
	  }, [(_vm.dataset.length == _vm.resultsPerPage && _vm.isLoadingRemaining) ? _c('div', {
	    staticClass: "row"
	  }, [_c('span', {
	    staticClass: "d-none d-lg-inline-block hidden-xs hidden-sm hidden-md",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_c('span', [_c('img', {
	    attrs: {
	      "src": "/static/img/ajax-loader.gif",
	      "alt": _vm.trans('loading')
	    }
	  }), _vm._v(" ${ trans(\"loading remaining athletes\") } ...")])])]) : _vm._e(), _vm._v(" "), (_vm.ajax | _vm.dataset.length > _vm.resultsPerPage) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('navigator', {
	    on: {
	      "changePage": _vm.setPg,
	      "movePage": _vm.mvPg
	    }
	  }, [_c('literal', {
	    attrs: {
	      "msgid": "prev",
	      "msgstr": _vm.trans('prev')
	    }
	  }), _vm._v(" "), _c('literal', {
	    attrs: {
	      "msgid": "next",
	      "msgstr": _vm.trans('next')
	    }
	  }), _vm._v(" "), _c('literal', {
	    attrs: {
	      "msgid": "previous",
	      "msgstr": _vm.trans('previous')
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 d-flex align-items-end justify-content-end"
	  }, _vm._l((_vm.downloads), function(link) {
	    return _c('a', {
	      attrs: {
	        "href": link.url
	      }
	    }, [_c('span', {
	      staticClass: "mr-1",
	      class: link.icon
	    }), _vm._v("${link.label}")])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 my-1"
	  }, [_c('div', {
	    staticClass: "input-group search-box"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchBox),
	      expression: "searchBox"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.trans('search')
	    },
	    domProps: {
	      "value": _vm._s(_vm.searchBox)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchBox = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.ajax) ? _c('span', {
	    staticClass: "input-group-btn input-group-append"
	  }, [_c('button', {
	    staticClass: "btn btn-sm btn-warning border-0",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('search', _vm.searchBox)
	      }
	    }
	  }, [_vm._v("Go")])]) : _c('span', {
	    staticClass: "input-group-btn input-group-append"
	  }, [_c('button', {
	    staticClass: "btn btn-sm btn-warning",
	    class: {
	      disabled: _vm.searchBox.trim().length == 0
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.searchBox = ''
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fas fa-times glyphicon glyphicon-remove"
	  })])])])])]) : _vm._e(), _vm._v(" "), _c('table', {
	    staticClass: "table bg-white",
	    staticStyle: {
	      "border-radius": "10px",
	      "overflow": "hidden"
	    }
	  }, [_vm._t("default"), _vm._v(" "), _c('thead', [_c('tr', _vm._l((_vm.headings), function(header) {
	    return _c('th', {
	      class: _vm.tdClass(header) + ' noselect'
	    }, [(header.funnel) ? _c('funnel', {
	      attrs: {
	        "key-name": header.val,
	        "key-func": header.lookup || null
	      },
	      on: {
	        "filtered": _vm.refilter
	      }
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(header.$el.innerHTML)
	      }
	    })]) : _c('span', [(header.order) ? _c('sorter', {
	      ref: header.val + 'Sorter',
	      refInFor: true,
	      attrs: {
	        "key-name": header.val
	      },
	      on: {
	        "reset": _vm.resetSort,
	        "sort": _vm.sortBy
	      }
	    }, [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(header.$el.innerHTML)
	      }
	    })]) : _c('span', {
	      domProps: {
	        "innerHTML": _vm._s(header.$el.innerHTML)
	      }
	    })], 1)], 1)
	  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.funneledResults()), function(row, i) {
	    return _c('tr', {
	      key: row[_vm.pk]
	    }, _vm._l((_vm.headings), function(header) {
	      return _c('td', {
	        class: _vm.tdClass(header)
	      }, [(header.flag || header.flag_url || row[header.val]) ? _c('div', {
	        style: ('background-image: url(' + _vm.safeFlag(row, header.flag || header.flag_url) + '); display: inline-block'),
	        attrs: {
	          "title": header.lookup ? _vm.invoke(header.lookup, row, header, i) : header.tooltip ? _vm.invoke(header.tooltip, row, header, i) : (row[header.val] || '-')
	        },
	        on: {
	          "error": _vm.$parent.handleBrokenImage,
	          "~click": function($event) {
	            _vm.$parent.tooltap($event)
	          }
	        }
	      }) : _vm._e(), _vm._v(" "), (header.link) ? _c('a', {
	        class: _vm.invoke(header.innerClass, row, header, i),
	        attrs: {
	          "href": _vm.baseUrl + row[_vm.pk] + '/'
	        }
	      }, [(header.lookup && header.flag || header.flag_url) ? _c('span', [_c('span', {
	        staticClass: "hidden-xs"
	      }, [_vm._v("${ invoke(header.lookup, row, header, i) }")]), _c('span', {
	        staticClass: "visible-xs"
	      }, [_vm._v("${ row[header.val] || '' }")])]) : _c('span', [(header.lookup) ? _c('span', [_vm._v("${ invoke(header.lookup, row, header, i) }")]) : _vm._e(), _vm._v(" "), (header.val) ? _c('span', {
	        directives: [{
	          name: "else",
	          rawName: "v-else"
	        }]
	      }, [_vm._v("${ row[header.val] || '' }")]) : _vm._e()])]) : _c('span', {
	        class: _vm.invoke(header.innerClass, row, header, i),
	        attrs: {
	          "title": header.tooltip && _vm.invoke(header.tooltip, row, header, i)
	        },
	        on: {
	          "click": function($event) {
	            header.action ? _vm.invoke(header.action, row, header, i) : false
	          },
	          "~click": function($event) {
	            header.tooltip && _vm.invoke(header.tooltip, row, header, i) ? _vm.$parent.tooltap($event) : false
	          }
	        }
	      }, [(header.lookup && !header.flag && !header.flag_url) ? _c('span', [_c('span', {
	        domProps: {
	          "innerHTML": _vm._s(_vm.invoke(header.lookup, row, header, i))
	        }
	      }), _vm._v(" "), (typeof(header.val) !== 'undefined') ? _c('span', {
	        staticClass: "visible-xs"
	      }, [_vm._v("${ row[header.val]  }")]) : _vm._e()]) : _vm._e(), _vm._v("\n\n                        {# if its a list of objects #}\n                        "), (header.datasetField && header.filter) ? _c('span', [_vm._v("${ arrayFilter(row, header, i) }")]) : _vm._e(), _vm._v(" "), (header.val) ? _c('span', {
	        directives: [{
	          name: "else",
	          rawName: "v-else"
	        }]
	      }, [_vm._v("${ row[header.val] || '' }")]) : _vm._e()]), _vm._v(" "), (header.extraVal && row[header.extraVal]) ? _c('span', {
	        class: header.extraVal
	      }, [_vm._v("${ row[header.extraVal] }")]) : _vm._e(), _vm._v(" "), (header.extraLookup && _vm.invoke(header.extraLookup, row, header, i)) ? _c('span', {
	        class: header.extraLookup
	      }, [_vm._v("${ invoke(header.extraLookup, row, header, i) }")]) : _vm._e(), _vm._v(" "), (header.lightbox && _vm.invoke(header.lightbox, row, header, i)) ? _c('span', [(_vm.isDialog(header.lighbox, row, header, i)) ? _c('button', {
	        staticClass: "btn btn-sm",
	        on: {
	          "click": function($event) {
	            _vm.openLightbox(row, header, i)
	          }
	        }
	      }, [_c('span', {
	        staticClass: "fa fa-mobile-alt glyphicon glyphicon-phone"
	      })]) : _c('a', {
	        staticClass: "btn btn-sm",
	        attrs: {
	          "target": "_blank",
	          "title": _vm.trans('new_window'),
	          "href": _vm.invoke(header.lightbox, row, header, i).url
	        }
	      }, [_c('span', {
	        staticClass: "fa fa-paperclip glyphicon glyphicon-paperclip"
	      })])]) : _vm._e()])
	    }))
	  }))], 2), _vm._v(" "), _c('navigator', {
	    on: {
	      "changePage": _vm.setPg,
	      "movePage": _vm.mvPg
	    }
	  }, [_c('literal', {
	    attrs: {
	      "msgid": "prev",
	      "msgstr": _vm.trans('prev')
	    }
	  }), _vm._v(" "), _c('literal', {
	    attrs: {
	      "msgid": "next",
	      "msgstr": _vm.trans('next')
	    }
	  }), _vm._v(" "), _c('literal', {
	    attrs: {
	      "msgid": "previous",
	      "msgstr": _vm.trans('previous')
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 316 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('a', {
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggle(_vm.keyName, $event)
	      }
	    }
	  }, [_vm._t("default"), _vm._v(" "), (_vm.direction === 'asc') ? _c('i', {
	    staticClass: "small fas fa-long-arrow-alt-down glyphicon glyphicon-arrow-down"
	  }) : _c('span', [(_vm.direction === 'desc') ? _c('i', {
	    staticClass: "small fas fa-long-arrow-alt-up glyphicon glyphicon-arrow-up"
	  }) : _vm._e()])], 2), _vm._v(" "), (_vm.direction.length > 0) ? _c('a', {
	    staticClass: "btn-sm",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reset(_vm.keyName, $event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-times glyphicon glyphicon-remove"
	  })]) : _c('span', {
	    staticClass: "small fas fa-arrows-alt-v glyphicon glyphicon-resize-vertical"
	  })])
	},staticRenderFns: []}

/***/ },
/* 317 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    class: 'card bg-steel mb-2' + (_vm.isSmallSearchVisible ? '' : ' d-none d-lg-flex'),
	    attrs: {
	      "id": "searchBox"
	    }
	  }, [_c('form', {
	    staticClass: "card-body form form-inline filter-form"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataGender),
	      expression: "dataGender"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "gender"
	    },
	    on: {
	      "change": [function($event) {
	        _vm.dataGender = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, _vm.cfilter]
	    }
	  }, _vm._l((_vm.genders), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option.value
	      }
	    }, [_vm._v(_vm._s(option.text))])
	  })), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataYear),
	      expression: "dataYear"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "year"
	    },
	    on: {
	      "change": [function($event) {
	        _vm.dataYear = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, _vm.cfilter]
	    }
	  }, _vm._l((_vm.periods), function(code) {
	    return _c('option', {
	      domProps: {
	        "value": code[0]
	      }
	    }, [_vm._v(_vm._s(code.length == 2 ? _vm.trans(code[1]) : code[0]))])
	  })), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataAgeGroup),
	      expression: "dataAgeGroup"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "agegroup",
	      "placeholder": "agegroup"
	    },
	    on: {
	      "change": [function($event) {
	        _vm.dataAgeGroup = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, _vm.cfilter]
	    }
	  }, _vm._l((_vm.ageGroups), function(code) {
	    return _c('option', {
	      domProps: {
	        "value": code[0]
	      }
	    }, [_vm._v(_vm._s(code.length == 2 ? _vm.trans(code[1]) : code[0]))])
	  })), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataIndoor),
	      expression: "dataIndoor"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "indoor",
	      "placeholder": "I/O"
	    },
	    on: {
	      "change": [function($event) {
	        _vm.dataIndoor = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, _vm.cfilter]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.trans('Outdoor')))]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v(_vm._s(_vm.trans('Indoor')))])]), _vm._v(" "), (_vm.eventCodes.length > 0) ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.dataEvent),
	      expression: "dataEvent"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "event",
	      "placeholder": "event"
	    },
	    on: {
	      "change": [function($event) {
	        _vm.dataEvent = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.cfilter($event, 1)
	      }]
	    }
	  }, _vm._l((_vm.eventCodes), function(code) {
	    return _c('option', {
	      domProps: {
	        "value": code[0]
	      }
	    }, [_vm._v(_vm._s(code[2]))])
	  })) : _vm._e(), _vm._v(" "), _c('button', {
	    class: 'ml-auto btn btn-primary border-0' + (_vm.state == 0 ? ' disabled' : ''),
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.loadTilastopaja()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.trans((_vm.state == 2) ? 'Get Rankings' : 'Get Events')))])])]), _vm._v(" "), _c('form', {
	    staticClass: "form form-horizontal form-inline"
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.current.country) + " " + _vm._s(_vm.current.year) + " " + _vm._s(_vm.current.event) + " " + _vm._s(_vm.current.indoor) + " " + _vm._s(_vm.current.gender))]), _vm._v(" "), (_vm.goodResponse) ? _c('table', {
	    staticClass: "table table-condensed bg-white",
	    style: ('opacity: ' + _vm.table_opacity()),
	    attrs: {
	      "bg-white": ""
	    }
	  }, [_c('thead', [_c('tr', {
	    staticClass: "bg-blue"
	  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Result')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Athlete')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Born')))]), _vm._v(" "), _c('th', {
	    staticClass: "d-none d-lg-table-cell"
	  }, [_vm._v(_vm._s(_vm.trans('Club')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Venue')))]), _vm._v(" "), _c('th', {
	    staticClass: "d-none d-lg-table-cell"
	  }, [_vm._v(_vm._s(_vm.trans('Competition')))]), _vm._v(" "), _c('th', {
	    staticClass: "d-none d-lg-table-cell"
	  }, [_vm._v(_vm._s(_vm.trans('Cat')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Date')))])])]), _vm._v(" "), (typeof _vm.expandedRankings[0] !== 'undefined') ? _c('tbody', _vm._l((_vm.expandedRankings), function(perf, i) {
	    return _c('tr', [(perf.rank) ? _c('td', [_vm._v(_vm._s(perf.rank))]) : _vm._e(), _vm._v(" "), (perf.combinedPerformances) ? _c('td', {
	      directives: [{
	        name: "else",
	        rawName: "v-else"
	      }],
	      ref: 'row' + i,
	      refInFor: true,
	      staticClass: "d-none d-md-table-cell py-1",
	      staticStyle: {
	        "border-top": "1px #FFF solid"
	      }
	    }) : _vm._e(), _vm._v(" "), (perf.combinedPerformances) ? _c('td', {
	      staticClass: "d-none d-md-table-cell bg-light py-1",
	      staticStyle: {
	        "font-size": ".9em",
	        "letter-spacing": "-.01rem"
	      },
	      attrs: {
	        "colspan": "5"
	      }
	    }, _vm._l((_vm.formattedPerformances(perf.combinedPerformances)), function(p) {
	      return _c('span', {
	        staticClass: "d-inline-block my-0 py-0 mx-1"
	      }, [_vm._v(_vm._s(p.value)), (p.wind) ? _c('i', {
	        staticClass: "text-muted"
	      }, [_vm._v("(" + _vm._s(p.wind) + ")")]) : _vm._e()])
	    })) : _vm._e(), _vm._v(" "), (perf.combinedPerformances) ? _c('td', {
	      staticClass: "d-table-cell d-md-none bg-light py-1",
	      staticStyle: {
	        "font-size": ".9em",
	        "letter-spacing": "-.01rem"
	      },
	      attrs: {
	        "colspan": "6"
	      }
	    }, _vm._l((_vm.formattedPerformances(perf.combinedPerformances)), function(p) {
	      return _c('span', {
	        staticClass: "d-inline-block my-0 py-0 mx-1"
	      }, [_vm._v(_vm._s(p.value)), (p.wind) ? _c('i', {
	        staticClass: "text-muted"
	      }, [_vm._v("(" + _vm._s(p.wind) + ")")]) : _vm._e()])
	    })) : _vm._e(), _vm._v(" "), (perf.rank) ? _c('td', [_vm._v("\n            " + _vm._s(perf.performance) + "\n            "), (perf.wind) ? _c('span', {
	      class: parseFloat(_vm.formatWind(perf.wind)) > 2.0 ? 'windy' : 'windOK'
	    }, [_vm._v(" (" + _vm._s(_vm.formatWind(perf.wind, true)) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (perf.rank) ? _c('td', [(perf.otAthleteId !== '' || perf.tpAthleteId !== '') ? _c('a', {
	      attrs: {
	        "href": _vm.personHref(perf)
	      }
	    }, [_c('i', [_vm._v(_vm._s(perf.givenName))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(perf.familyName))])]) : _c('span', [_c('i', [_vm._v(_vm._s(perf.givenName))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(perf.familyName))])])]) : _vm._e(), _vm._v(" "), (perf.rank) ? _c('td', [(perf.birthDate) ? _c('span', {
	      staticClass: "text-muted"
	    }, [_vm._v(_vm._s(_vm.showBirth(perf.birthDate)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (perf.rank) ? _c('td', {
	      staticClass: "d-none d-lg-table-cell club"
	    }, [(perf.club !== '' && perf.club && perf.club.toLowerCase) ? _c('a', {
	      attrs: {
	        "href": '/orgs/' + perf.club.toLowerCase()
	      }
	    }, [_vm._v(_vm._s(perf.club))]) : _c('span', [_vm._v(_vm._s(perf.club))])]) : _vm._e(), _vm._v(" "), (perf.rank) ? _c('td', {
	      attrs: {
	        "rowspan": _vm.expandedRankings.length > i && _vm.expandedRankings[i + 1].hasOwnProperty('combinedPerformances') ? 2 : 1
	      }
	    }, [_vm._v(_vm._s(perf.cityName))]) : _vm._e(), _vm._v(" "), (perf.rank) ? _c('td', {
	      staticClass: "d-none d-lg-table-cell ellipsis",
	      staticStyle: {
	        "width": "200px"
	      },
	      attrs: {
	        "rowspan": _vm.expandedRankings.length > i && _vm.expandedRankings[i + 1].hasOwnProperty('combinedPerformances') ? 2 : 1
	      }
	    }, [_vm._v(_vm._s(perf.info))]) : _vm._e(), _vm._v(" "), (perf.rank) ? _c('td', {
	      staticClass: "d-none d-lg-table-cell",
	      attrs: {
	        "rowspan": _vm.expandedRankings.length > i && _vm.expandedRankings[i + 1].hasOwnProperty('combinedPerformances') ? 2 : 1
	      }
	    }, [_c('b', [_vm._v(_vm._s(perf.waCompCategory))])]) : _vm._e(), _vm._v(" "), (perf.rank) ? _c('td', {
	      staticClass: "pr-0"
	    }, [_c('span', {
	      staticClass: "d-inline-block d-lg-none mr-0 pr-0 text-nowrap"
	    }, [_vm._v(_vm._s(_vm.dataYear !== "ALLT" ? perf.date.substr(5) : new Date(perf.date).toLocaleDateString()))]), _vm._v(" "), _c('span', {
	      staticClass: "d-none d-lg-inline-block"
	    }, [_vm._v(_vm._s(new Date(perf.date).toLocaleDateString()))])]) : _vm._e()])
	  })) : _c('tbody', [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "8"
	    }
	  }, [_c('b', [_c('i', [_vm._v(_vm._s(_vm.trans('No data')))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.goodResponse) ? _c('p', {
	    staticClass: "d-none d-lg-block"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.directUrl()
	    }
	  }, [_vm._v(_vm._s(_vm.trans('Direct URL')) + ": " + _vm._s(_vm.directUrl()))])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('div', [(_vm.jsonUrl) ? _c('p', [_c('a', {
	    attrs: {
	      "href": _vm.jsonUrl
	    }
	  }, [_vm._v("<raw rankings data>")])]) : _vm._e(), _vm._v(" "), (_vm.jsonUrlEvents) ? _c('p', [_c('a', {
	    attrs: {
	      "href": _vm.jsonUrlEvents
	    }
	  }, [_vm._v("<raw events data>")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 318 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "component-two"
	  }, [_c('p', [_vm._v("Component Two (should be blue)")])])
	}]}

/***/ },
/* 319 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.showName) ? _c('h3', {
	    attrs: {
	      "name": "top"
	    }
	  }, [_vm._v(_vm._s(_vm.tilpa.givenName) + " " + _vm._s(_vm.tilpa.familyName))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "bests"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.trans('Bests')))]), _vm._v(" "), _c('table', {
	    staticClass: "table table-striped table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.trans('Event')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('PB')))]), _vm._v(" "), _vm._l((_vm.displayYears), function(year) {
	    return _c('th', [_vm._v(_vm._s(year))])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.bestsByYearAndEvent), function(row) {
	    return _c('tr', _vm._l((row), function(cell, colIndex) {
	      return _c('td', [(typeof cell !== 'undefined' && cell[1]) ? _c('a', {
	        class: {
	          pb: colIndex > 1 && (cell[0] == row[1][0])
	        },
	        attrs: {
	          "href": '#' + cell[1]
	        },
	        on: {
	          "click": _vm.highlight
	        }
	      }, [_vm._v("\n                " + _vm._s(typeof cell !== 'undefined' ? cell[0] : '') + "\n                ")]) : _c('span', [_vm._v("\n                " + _vm._s(typeof cell !== 'undefined' ? cell[0] : '') + "\n                ")])])
	    }))
	  }))])]), _vm._v(" "), _c('div', {
	    staticClass: "performances"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.trans('Performances')))]), _vm._v(" "), _c('div', {
	    staticClass: "panel-group",
	    attrs: {
	      "id": "accordion",
	      "role": "tablist",
	      "aria-multiselectable": "true"
	    }
	  }, _vm._l((_vm.resultsByYear), function(perfs, index) {
	    return _c('div', {
	      staticClass: "panel panel-default"
	    }, [_c('div', {
	      staticClass: "panel-heading",
	      attrs: {
	        "role": "tab",
	        "id": 'heading' + index
	      }
	    }, [_vm._m(0, true), _vm._v(" "), _c('a', {
	      staticClass: "panel-title",
	      attrs: {
	        "role": "button",
	        "data-toggle": "collapse",
	        "data-parent": "#accordion",
	        "href": '#collapse' + index,
	        "aria-expanded": "true",
	        "aria-controls": 'collapse' + index,
	        "name": perfs[0].date.substr(0, 4)
	      }
	    }, [_vm._v("\n            " + _vm._s(perfs[0].date.substr(0, 4)) + "\n          ")])]), _vm._v(" "), _c('div', {
	      staticClass: "panel-collapse collapse in",
	      attrs: {
	        "id": 'collapse' + index,
	        "role": "tabpanel",
	        "aria-labelledby": 'heading' + index
	      }
	    }, [_c('a', {
	      attrs: {
	        "name": ""
	      }
	    }), _vm._v(" "), _c('table', {
	      staticClass: "table table-striped table-condensed"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.trans('Date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Discipline')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Result')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Rank')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Venue')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.trans('Category')))])])]), _vm._v(" "), _c('tbody', _vm._l((perfs), function(perf) {
	      return _c('tr', [_c('td', [_vm._v(_vm._s(new Date(perf.date).toLocaleDateString()))]), _vm._v(" "), _c('td', {
	        class: {
	          indoor: perf.IndoorOutdoor == 'Indoor'
	        }
	      }, [_vm._v(_vm._s(perf.event))]), _vm._v(" "), _c('td', [_c('a', {
	        attrs: {
	          "name": perf.id
	        }
	      }, [_vm._v(_vm._s(perf.result) + "\n                  "), (perf.wind) ? _c('span', {
	        class: parseFloat(_vm.formatWind(perf.wind)) > 2.0 ? 'windy' : 'windOK'
	      }, [_vm._v("\n                          (" + _vm._s(_vm.formatWind(perf.wind, true)) + ")\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(perf.rank) + " "), (perf.round) ? _c('span', [_vm._v("(" + _vm._s(perf.round) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(perf.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(perf.agegroup))])])
	    }))])])])
	  }))]), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "pull-right text-muted",
	    attrs: {
	      "href": "#top"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-circle-arrow-up"
	  }), _c('small', {
	    staticClass: "sr-only"
	  }, [_vm._v("top")])])
	}]}

/***/ },
/* 320 */,
/* 321 */,
/* 322 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.js